(function (window, document, $, undefined) {
  function uriParamValueToLocalStorage(e, t) {
    if (-1 < window.location.search.indexOf(e + "=")) {
      windowLocationSearch = window.location.search;
      var n = windowLocationSearch.split(e + "=")[1].split("&")[0];
      localStorage.setItem(t, n),
        -1 < window.location.href.indexOf("moosend1.staging") &&
          (console.log(e + ": " + n),
          console.log(t + ": " + localStorage.getItem(t)));
    }
  }

  !(function (e) {
    if ("object" == typeof exports && "undefined" != typeof module)
      module.exports = e();
    else if ("function" == typeof define && define.amd) define([], e);
    else {
      ("undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : this
      ).Cocoen = e();
    }
  })(function () {
    return (function r(s, a, l) {
      function c(n, e) {
        if (!a[n]) {
          if (!s[n]) {
            var t = "function" == typeof require && require;
            if (!e && t) return t(n, !0);
            if (d) return d(n, !0);
            var i = new Error("Cannot find module '" + n + "'");
            throw ((i.code = "MODULE_NOT_FOUND"), i);
          }
          var o = (a[n] = {
            exports: {},
          });
          s[n][0].call(
            o.exports,
            function (e) {
              var t = s[n][1][e];
              return c(t || e);
            },
            o,
            o.exports,
            r,
            s,
            a,
            l
          );
        }
        return a[n].exports;
      }
      for (
        var d = "function" == typeof require && require, e = 0;
        e < l.length;
        e++
      )
        c(l[e]);
      return c;
    })(
      {
        1: [
          function (e, t, n) {
            "use strict";
            var i =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var i in n)
                      Object.prototype.hasOwnProperty.call(n, i) &&
                        (e[i] = n[i]);
                  }
                  return e;
                },
              o =
                ((function (e, t, n) {
                  return t && s(e.prototype, t), n && s(e, n), e;
                })(r, [
                  {
                    key: "init",
                    value: function () {
                      this.createElements(),
                        this.addEventListeners(),
                        this.dimensions();
                    },
                  },
                  {
                    key: "createElements",
                    value: function () {
                      var e = document.createElement("span");
                      (e.className = this.options.dragElementSelector.replace(
                        ".",
                        ""
                      )),
                        this.element.appendChild(e);
                      var t = document.createElement("div"),
                        n = this.element.querySelector("img:first-child");
                      t.appendChild(n.cloneNode(!0)),
                        n.parentNode.replaceChild(t, n),
                        (this.dragElement = this.element.querySelector(
                          this.options.dragElementSelector
                        )),
                        (this.beforeElement =
                          this.element.querySelector("div:first-child")),
                        (this.beforeImage =
                          this.beforeElement.querySelector("img"));
                    },
                  },
                  {
                    key: "addEventListeners",
                    value: function () {
                      this.element.addEventListener(
                        "click",
                        this.onTap.bind(this)
                      ),
                        this.element.addEventListener(
                          "mousemove",
                          this.onDrag.bind(this)
                        ),
                        this.element.addEventListener(
                          "touchmove",
                          this.onDrag.bind(this)
                        ),
                        this.dragElement.addEventListener(
                          "mousedown",
                          this.onDragStart.bind(this)
                        ),
                        this.dragElement.addEventListener(
                          "touchstart",
                          this.onDragStart.bind(this)
                        ),
                        window.addEventListener(
                          "mouseup",
                          this.onDragEnd.bind(this)
                        ),
                        window.addEventListener(
                          "resize",
                          this.dimensions.bind(this)
                        );
                    },
                  },
                  {
                    key: "dimensions",
                    value: function () {
                      (this.elementWidth = parseInt(
                        window.getComputedStyle(this.element).width,
                        10
                      )),
                        (this.elementOffsetLeft =
                          this.element.getBoundingClientRect().left +
                          document.body.scrollLeft),
                        (this.beforeImage.style.width =
                          this.elementWidth + "px"),
                        (this.dragElementWidth = parseInt(
                          window.getComputedStyle(this.dragElement).width,
                          10
                        )),
                        (this.minLeftPos = this.elementOffsetLeft + 10),
                        (this.maxLeftPos =
                          this.elementOffsetLeft +
                          this.elementWidth -
                          this.dragElementWidth -
                          10);
                    },
                  },
                  {
                    key: "onTap",
                    value: function (e) {
                      e.preventDefault(),
                        (this.leftPos = e.pageX ? e.pageX : e.touches[0].pageX),
                        this.requestDrag();
                    },
                  },
                  {
                    key: "onDragStart",
                    value: function (e) {
                      e.preventDefault();
                      var t = e.pageX ? e.pageX : e.touches[0].pageX,
                        n =
                          this.dragElement.getBoundingClientRect().left +
                          document.body.scrollLeft;
                      (this.posX = n + this.dragElementWidth - t),
                        (this.isDragging = !0);
                    },
                  },
                  {
                    key: "onDragEnd",
                    value: function (e) {
                      e.preventDefault(), (this.isDragging = !1);
                    },
                  },
                  {
                    key: "onDrag",
                    value: function (e) {
                      e.preventDefault(),
                        this.isDragging &&
                          ((this.moveX = e.pageX
                            ? e.pageX
                            : e.touches[0].pageX),
                          (this.leftPos =
                            this.moveX + this.posX - this.dragElementWidth),
                          this.requestDrag());
                    },
                  },
                  {
                    key: "drag",
                    value: function () {
                      this.leftPos < this.minLeftPos
                        ? (this.leftPos = this.minLeftPos)
                        : this.leftPos > this.maxLeftPos &&
                          (this.leftPos = this.maxLeftPos);
                      var e =
                          this.leftPos +
                          this.dragElementWidth / 2 -
                          this.elementOffsetLeft,
                        t = 100 * (e /= this.elementWidth) + "%";
                      (this.dragElement.style.left = t),
                        (this.beforeElement.style.width = t),
                        this.options.dragCallback &&
                          this.options.dragCallback(e);
                    },
                  },
                  {
                    key: "requestDrag",
                    value: function () {
                      window.requestAnimationFrame(this.drag.bind(this));
                    },
                  },
                ]),
                r);

            function r(e, t) {
              (function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, r),
                (this.options = i({}, r.defaults, t)),
                (this.element = e || document.querySelector(".cocoen")),
                this.init();
            }

            function s(e, t) {
              for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            (o.defaults = {
              dragElementSelector: ".cocoen-drag",
              dragCallback: null,
            }),
              (t.exports = o);
          },
          {},
        ],
      },
      {},
      [1]
    )(1);
  }),
    (function r(s, a, l) {
      function c(n, e) {
        if (!a[n]) {
          if (!s[n]) {
            var t = "function" == typeof require && require;
            if (!e && t) return t(n, !0);
            if (d) return d(n, !0);
            var i = new Error("Cannot find module '" + n + "'");
            throw ((i.code = "MODULE_NOT_FOUND"), i);
          }
          var o = (a[n] = {
            exports: {},
          });
          s[n][0].call(
            o.exports,
            function (e) {
              var t = s[n][1][e];
              return c(t || e);
            },
            o,
            o.exports,
            r,
            s,
            a,
            l
          );
        }
        return a[n].exports;
      }
      for (
        var d = "function" == typeof require && require, e = 0;
        e < l.length;
        e++
      )
        c(l[e]);
      return c;
    })(
      {
        1: [
          function (e, t, n) {
            "use strict";
            var i, o;
            (i = window.jQuery),
              (o = window.Cocoen),
              i &&
                o &&
                (i.fn.cocoen = function (e) {
                  return this.each(function () {
                    return new o(this, i.extend({}, o.defaults, e));
                  });
                });
          },
          {},
        ],
      },
      {},
      [1]
    ),
    (function (e, t) {
      "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? module.exports = t() : e.ScrollMagic = t();
    })(typeof window !== "undefined" ? window : this, function () {
      "use strict";

      function O() {}
      (O.version = "2.0.7"),
        window.addEventListener("mousewheel", function () {});
      var N = "data-scrollmagic-pin-spacer";
      O.Controller = function (e) {
        function n() {
          0 < u.refreshInterval &&
            (a = window.setTimeout(x, u.refreshInterval));
        }

        function i() {
          return u.vertical
            ? H.get.height(u.container)
            : H.get.width(u.container);
        }

        function t() {
          if (y && f) {
            var e = H.type.Array(f) ? f : p.slice(0);
            f = !1;
            var t = h,
              n = (h = d.scrollPos()) - t;
            0 != n && (g = 0 < n ? "FORWARD" : l),
              g === l && e.reverse(),
              e.forEach(function (e, t) {
                e.update(!0);
              });
          }
        }

        function o() {
          s = H.rAF(t);
        }

        function r(e) {
          "resize" == e.type && ((v = i()), (g = "PAUSED")),
            !0 !== f && ((f = !0), o());
        }
        var s,
          a,
          l = "REVERSE",
          c = T.defaults,
          d = this,
          u = H.extend({}, c, e),
          p = [],
          f = !1,
          h = 0,
          g = "PAUSED",
          m = !0,
          v = 0,
          y = !0,
          w = function () {
            return u.vertical
              ? H.get.scrollTop(u.container)
              : H.get.scrollLeft(u.container);
          },
          b = (this._setScrollPos = function (e) {
            u.vertical
              ? m
                ? window.scrollTo(H.get.scrollLeft(), e)
                : (u.container.scrollTop = e)
              : m
              ? window.scrollTo(e, H.get.scrollTop())
              : (u.container.scrollLeft = e);
          }),
          x = function () {
            if (!m && v != i()) {
              var t;
              try {
                t = new Event("resize", {
                  bubbles: !1,
                  cancelable: !1,
                });
              } catch (e) {
                (t = document.createEvent("Event")).initEvent("resize", !1, !1);
              }
              u.container.dispatchEvent(t);
            }
            p.forEach(function (e, t) {
              e.refresh();
            }),
              n();
          };
        this._options = u;

        function S(e) {
          if (e.length <= 1) return e;
          var t = e.slice(0);
          return (
            t.sort(function (e, t) {
              return e.scrollOffset() > t.scrollOffset() ? 1 : -1;
            }),
            t
          );
        }
        return (
          (this.addScene = function (e) {
            if (H.type.Array(e))
              e.forEach(function (e, t) {
                d.addScene(e);
              });
            else if (e instanceof O.Scene)
              if (e.controller() !== d) e.addTo(d);
              else if (p.indexOf(e) < 0)
                for (var t in (p.push(e),
                (p = S(p)),
                e.on("shift.controller_sort", function () {
                  p = S(p);
                }),
                u.globalSceneOptions))
                  e[t] && e[t].call(e, u.globalSceneOptions[t]);
            return d;
          }),
          (this.removeScene = function (e) {
            if (H.type.Array(e))
              e.forEach(function (e, t) {
                d.removeScene(e);
              });
            else {
              var t = p.indexOf(e);
              -1 < t &&
                (e.off("shift.controller_sort"), p.splice(t, 1), e.remove());
            }
            return d;
          }),
          (this.updateScene = function (e, n) {
            return (
              H.type.Array(e)
                ? e.forEach(function (e, t) {
                    d.updateScene(e, n);
                  })
                : n
                ? e.update(!0)
                : !0 !== f &&
                  e instanceof O.Scene &&
                  (-1 == (f = f || []).indexOf(e) && f.push(e),
                  (f = S(f)),
                  o()),
              d
            );
          }),
          (this.update = function (e) {
            return (
              r({
                type: "resize",
              }),
              e && t(),
              d
            );
          }),
          (this.scrollTo = function (e, t) {
            if (H.type.Number(e)) b.call(u.container, e, t);
            else if (e instanceof O.Scene)
              e.controller() === d && d.scrollTo(e.scrollOffset(), t);
            else if (H.type.Function(e)) b = e;
            else {
              var n = H.get.elements(e)[0];
              if (n) {
                for (; n.parentNode.hasAttribute(N); ) n = n.parentNode;
                var i = u.vertical ? "top" : "left",
                  o = H.get.offset(u.container),
                  r = H.get.offset(n);
                m || (o[i] -= d.scrollPos()), d.scrollTo(r[i] - o[i], t);
              }
            }
            return d;
          }),
          (this.scrollPos = function (e) {
            return arguments.length
              ? (H.type.Function(e) && (w = e), d)
              : w.call(d);
          }),
          (this.info = function (e) {
            var t = {
              size: v,
              vertical: u.vertical,
              scrollPos: h,
              scrollDirection: g,
              container: u.container,
              isDocument: m,
            };
            return arguments.length ? (void 0 !== t[e] ? t[e] : void 0) : t;
          }),
          (this.loglevel = function (e) {
            return d;
          }),
          (this.enabled = function (e) {
            return arguments.length
              ? (y != e && ((y = !!e), d.updateScene(p, !0)), d)
              : y;
          }),
          (this.destroy = function (e) {
            window.clearTimeout(a);
            for (var t = p.length; t--; ) p[t].destroy(e);
            return (
              u.container.removeEventListener("resize", r),
              u.container.removeEventListener("scroll", r),
              H.cAF(s),
              null
            );
          }),
          (function () {
            for (var e in u) c.hasOwnProperty(e) || delete u[e];
            if (((u.container = H.get.elements(u.container)[0]), !u.container))
              throw "ScrollMagic.Controller init failed.";
            (m =
              u.container === window ||
              u.container === document.body ||
              !document.body.contains(u.container)) && (u.container = window),
              (v = i()),
              u.container.addEventListener("resize", r),
              u.container.addEventListener("scroll", r);
            var t = parseInt(u.refreshInterval, 10);
            (u.refreshInterval = H.type.Number(t) ? t : c.refreshInterval), n();
          })(),
          d
        );
      };
      var T = {
        defaults: {
          container: window,
          vertical: !0,
          globalSceneOptions: {},
          loglevel: 2,
          refreshInterval: 100,
        },
      };
      (O.Controller.addOption = function (e, t) {
        T.defaults[e] = t;
      }),
        (O.Controller.extend = function (e) {
          var t = this;
          (O.Controller = function () {
            return (
              t.apply(this, arguments),
              (this.$super = H.extend({}, this)),
              e.apply(this, arguments) || this
            );
          }),
            H.extend(O.Controller, t),
            (O.Controller.prototype = t.prototype),
            (O.Controller.prototype.constructor = O.Controller);
        }),
        (O.Scene = function (e) {
          var n,
            l,
            c = "BEFORE",
            d = "DURING",
            u = "AFTER",
            i = P.defaults,
            p = this,
            f = H.extend({}, i, e),
            h = c,
            g = 0,
            a = {
              start: 0,
              end: 0,
            },
            m = 0,
            o = !0,
            s = {};
          (this.on = function (e, o) {
            return (
              H.type.Function(o) &&
                (e = e.trim().split(" ")).forEach(function (e) {
                  var t = e.split("."),
                    n = t[0],
                    i = t[1];
                  "*" != n &&
                    (s[n] || (s[n] = []),
                    s[n].push({
                      namespace: i || "",
                      callback: o,
                    }));
                }),
              p
            );
          }),
            (this.off = function (e, r) {
              return (
                e &&
                  (e = e.trim().split(" ")).forEach(function (e, t) {
                    var n = e.split("."),
                      i = n[0],
                      o = n[1] || "";
                    ("*" === i ? Object.keys(s) : [i]).forEach(function (e) {
                      for (var t = s[e] || [], n = t.length; n--; ) {
                        var i = t[n];
                        !i ||
                          (o !== i.namespace && "*" !== o) ||
                          (r && r != i.callback) ||
                          t.splice(n, 1);
                      }
                      t.length || delete s[e];
                    });
                  }),
                p
              );
            }),
            (this.trigger = function (e, n) {
              if (e) {
                var t = e.trim().split("."),
                  i = t[0],
                  o = t[1],
                  r = s[i];
                r &&
                  r.forEach(function (e, t) {
                    (o && o !== e.namespace) ||
                      e.callback.call(p, new O.Event(i, e.namespace, p, n));
                  });
              }
              return p;
            }),
            p
              .on("change.internal", function (e) {
                "loglevel" !== e.what &&
                  "tweenChanges" !== e.what &&
                  ("triggerElement" === e.what
                    ? b()
                    : "reverse" === e.what && p.update());
              })
              .on("shift.internal", function (e) {
                t(), p.update();
              }),
            (this.addTo = function (e) {
              return (
                e instanceof O.Controller &&
                  l != e &&
                  (l && l.removeScene(p),
                  (l = e),
                  T(),
                  w(!0),
                  b(!0),
                  t(),
                  l.info("container").addEventListener("resize", x),
                  e.addScene(p),
                  p.trigger("add", {
                    controller: l,
                  }),
                  p.update()),
                p
              );
            }),
            (this.enabled = function (e) {
              return arguments.length
                ? (o != e && ((o = !!e), p.update(!0)), p)
                : o;
            }),
            (this.remove = function () {
              if (l) {
                l.info("container").removeEventListener("resize", x);
                var e = l;
                (l = void 0), e.removeScene(p), p.trigger("remove");
              }
              return p;
            }),
            (this.destroy = function (e) {
              return (
                p.trigger("destroy", {
                  reset: e,
                }),
                p.remove(),
                p.off("*.*"),
                null
              );
            }),
            (this.update = function (e) {
              if (l)
                if (e)
                  if (l.enabled() && o) {
                    var t,
                      n = l.info("scrollPos");
                    (t =
                      0 < f.duration
                        ? (n - a.start) / (a.end - a.start)
                        : n >= a.start
                        ? 1
                        : 0),
                      p.trigger("update", {
                        startPos: a.start,
                        endPos: a.end,
                        scrollPos: n,
                      }),
                      p.progress(t);
                  } else v && h === d && A(!0);
                else l.updateScene(p, !1);
              return p;
            }),
            (this.refresh = function () {
              return w(), b(), p;
            }),
            (this.progress = function (e) {
              if (arguments.length) {
                var t = !1,
                  n = h,
                  i = l ? l.info("scrollDirection") : "PAUSED",
                  o = f.reverse || g <= e;
                if (
                  (0 === f.duration
                    ? ((t = g != e),
                      (h = 0 == (g = e < 1 && o ? 0 : 1) ? c : d))
                    : e < 0 && h !== c && o
                    ? ((h = c), (t = !(g = 0)))
                    : 0 <= e && e < 1 && o
                    ? ((g = e), (h = d), (t = !0))
                    : 1 <= e && h !== u
                    ? ((g = 1), (h = u), (t = !0))
                    : h !== d || o || A(),
                  t)
                ) {
                  var r = {
                      progress: g,
                      state: h,
                      scrollDirection: i,
                    },
                    s = h != n,
                    a = function (e) {
                      p.trigger(e, r);
                    };
                  s && n !== d && (a("enter"), a(n === c ? "start" : "end")),
                    a("progress"),
                    s && h !== d && (a(h === c ? "start" : "end"), a("leave"));
                }
                return p;
              }
              return g;
            });

          function r(t) {
            p[t] ||
              (p[t] = function (e) {
                return arguments.length
                  ? ("duration" === t && (n = void 0),
                    k(t, e) &&
                      (p.trigger("change", {
                        what: t,
                        newval: f[t],
                      }),
                      -1 < P.shifts.indexOf(t) &&
                        p.trigger("shift", {
                          reason: t,
                        })),
                    p)
                  : f[t];
              });
          }
          var v,
            y,
            t = function () {
              (a = {
                start: m + f.offset,
              }),
                l &&
                  f.triggerElement &&
                  (a.start -= l.info("size") * f.triggerHook),
                (a.end = a.start + f.duration);
            },
            w = function (e) {
              if (n) {
                var t = "duration";
                k(t, n.call(p)) &&
                  !e &&
                  (p.trigger("change", {
                    what: t,
                    newval: f[t],
                  }),
                  p.trigger("shift", {
                    reason: t,
                  }));
              }
            },
            b = function (e) {
              var t = 0,
                n = f.triggerElement;
              if (l && (n || 0 < m)) {
                if (n)
                  if (n.parentNode) {
                    for (
                      var i = l.info(),
                        o = H.get.offset(i.container),
                        r = i.vertical ? "top" : "left";
                      n.parentNode.hasAttribute(N);

                    )
                      n = n.parentNode;
                    var s = H.get.offset(n);
                    i.isDocument || (o[r] -= l.scrollPos()), (t = s[r] - o[r]);
                  } else p.triggerElement(void 0);
                var a = t != m;
                (m = t),
                  a &&
                    !e &&
                    p.trigger("shift", {
                      reason: "triggerElementPosition",
                    });
              }
            },
            x = function (e) {
              0 < f.triggerHook &&
                p.trigger("shift", {
                  reason: "containerResize",
                });
            },
            S = H.extend(P.validate, {
              duration: function (e) {
                if (H.type.String(e) && e.match(/^(\.|\d)*\d+%$/)) {
                  var t = parseFloat(e) / 100;
                  e = function () {
                    return l ? l.info("size") * t : 0;
                  };
                }
                if (H.type.Function(e)) {
                  n = e;
                  try {
                    e = parseFloat(n.call(p));
                  } catch (t) {
                    e = -1;
                  }
                }
                if (((e = parseFloat(e)), !H.type.Number(e) || e < 0))
                  throw ((n = n && void 0), 0);
                return e;
              },
            }),
            T = function (e) {
              (e = arguments.length ? [e] : Object.keys(S)).forEach(function (
                e,
                t
              ) {
                var n;
                if (S[e])
                  try {
                    n = S[e](f[e]);
                  } catch (t) {
                    n = i[e];
                  } finally {
                    f[e] = n;
                  }
              });
            },
            k = function (e, t) {
              var n = !1,
                i = f[e];
              return f[e] != t && ((f[e] = t), T(e), (n = i != f[e])), n;
            };
          (this.controller = function () {
            return l;
          }),
            (this.state = function () {
              return h;
            }),
            (this.scrollOffset = function () {
              return a.start;
            }),
            (this.triggerPosition = function () {
              var e = f.offset;
              return (
                l &&
                  (f.triggerElement
                    ? (e += m)
                    : (e += l.info("size") * p.triggerHook())),
                e
              );
            }),
            p
              .on("shift.internal", function (e) {
                var t = "duration" === e.reason;
                ((h === u && t) || (h === d && 0 === f.duration)) && A(),
                  t && D();
              })
              .on("progress.internal", function (e) {
                A();
              })
              .on("add.internal", function (e) {
                D();
              })
              .on("destroy.internal", function (e) {
                p.removePin(e.reset);
              });

          function $() {
            l && v && h === d && !l.info("isDocument") && A();
          }

          function C() {
            l &&
              v &&
              h === d &&
              (((y.relSize.width || y.relSize.autoFullWidth) &&
                H.get.width(window) != H.get.width(y.spacer.parentNode)) ||
                (y.relSize.height &&
                  H.get.height(window) != H.get.height(y.spacer.parentNode))) &&
              D();
          }

          function E(e) {
            l &&
              v &&
              h === d &&
              !l.info("isDocument") &&
              (e.preventDefault(),
              l._setScrollPos(
                l.info("scrollPos") -
                  ((e.wheelDelta ||
                    e[l.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) /
                    3 || 30 * -e.detail)
              ));
          }
          var A = function (e) {
              if (v && l) {
                var t = l.info(),
                  n = y.spacer.firstChild;
                if (e || h !== d) {
                  var i = {
                      position: y.inFlow ? "relative" : "absolute",
                      top: 0,
                      left: 0,
                    },
                    o = H.css(n, "position") != i.position;
                  y.pushFollowers
                    ? 0 < f.duration &&
                      (h === u &&
                      0 === parseFloat(H.css(y.spacer, "padding-top"))
                        ? (o = !0)
                        : h === c &&
                          0 === parseFloat(H.css(y.spacer, "padding-bottom")) &&
                          (o = !0))
                    : (i[t.vertical ? "top" : "left"] = f.duration * g),
                    H.css(n, i),
                    o && D();
                } else {
                  "fixed" != H.css(n, "position") &&
                    (H.css(n, {
                      position: "fixed",
                    }),
                    D());
                  var r = H.get.offset(y.spacer, !0),
                    s =
                      f.reverse || 0 === f.duration
                        ? t.scrollPos - a.start
                        : Math.round(g * f.duration * 10) / 10;
                  (r[t.vertical ? "top" : "left"] += s),
                    H.css(y.spacer.firstChild, {
                      top: r.top,
                      left: r.left,
                    });
                }
              }
            },
            D = function () {
              if (v && l && y.inFlow) {
                var e = h === d,
                  t = l.info("vertical"),
                  n = y.spacer.firstChild,
                  i = H.isMarginCollapseType(H.css(y.spacer, "display")),
                  o = {};
                y.relSize.width || y.relSize.autoFullWidth
                  ? e
                    ? H.css(v, {
                        width: H.get.width(y.spacer),
                      })
                    : H.css(v, {
                        width: "100%",
                      })
                  : ((o["min-width"] = H.get.width(t ? v : n, !0, !0)),
                    (o.width = e ? o["min-width"] : "auto")),
                  y.relSize.height
                    ? e
                      ? H.css(v, {
                          height:
                            H.get.height(y.spacer) -
                            (y.pushFollowers ? f.duration : 0),
                        })
                      : H.css(v, {
                          height: "100%",
                        })
                    : ((o["min-height"] = H.get.height(t ? n : v, !0, !i)),
                      (o.height = e ? o["min-height"] : "auto")),
                  y.pushFollowers &&
                    ((o["padding" + (t ? "Top" : "Left")] = f.duration * g),
                    (o["padding" + (t ? "Bottom" : "Right")] =
                      f.duration * (1 - g))),
                  H.css(y.spacer, o);
              }
            };
          (this.setPin = function (e, t) {
            if (
              ((t = H.extend(
                {},
                {
                  pushFollowers: !0,
                  spacerClass: "scrollmagic-pin-spacer",
                },
                t
              )),
              !(e = H.get.elements(e)[0]))
            )
              return p;
            if ("fixed" === H.css(e, "position")) return p;
            if (v) {
              if (v === e) return p;
              p.removePin();
            }
            var n = (v = e).parentNode.style.display,
              i = [
                "top",
                "left",
                "bottom",
                "right",
                "margin",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
              ];
            v.parentNode.style.display = "none";
            var o = "absolute" != H.css(v, "position"),
              r = H.css(v, i.concat(["display"])),
              s = H.css(v, ["width", "height"]);
            (v.parentNode.style.display = n),
              !o && t.pushFollowers && (t.pushFollowers = !1);
            var a = v.parentNode.insertBefore(document.createElement("div"), v),
              l = H.extend(r, {
                position: o ? "relative" : "absolute",
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box",
              });
            if (
              (o || H.extend(l, H.css(v, ["width", "height"])),
              H.css(a, l),
              a.setAttribute(N, ""),
              H.addClass(a, t.spacerClass),
              (y = {
                spacer: a,
                relSize: {
                  width: "%" === s.width.slice(-1),
                  height: "%" === s.height.slice(-1),
                  autoFullWidth:
                    "auto" === s.width &&
                    o &&
                    H.isMarginCollapseType(r.display),
                },
                pushFollowers: t.pushFollowers,
                inFlow: o,
              }),
              !v.___origStyle)
            ) {
              v.___origStyle = {};
              var c = v.style;
              i.concat([
                "width",
                "height",
                "position",
                "boxSizing",
                "mozBoxSizing",
                "webkitBoxSizing",
              ]).forEach(function (e) {
                v.___origStyle[e] = c[e] || "";
              });
            }
            return (
              y.relSize.width &&
                H.css(a, {
                  width: s.width,
                }),
              y.relSize.height &&
                H.css(a, {
                  height: s.height,
                }),
              a.appendChild(v),
              H.css(v, {
                position: o ? "relative" : "absolute",
                margin: "auto",
                top: "auto",
                left: "auto",
                bottom: "auto",
                right: "auto",
              }),
              (y.relSize.width || y.relSize.autoFullWidth) &&
                H.css(v, {
                  boxSizing: "border-box",
                  mozBoxSizing: "border-box",
                  webkitBoxSizing: "border-box",
                }),
              window.addEventListener("scroll", $),
              window.addEventListener("resize", $),
              window.addEventListener("resize", C),
              v.addEventListener("mousewheel", E),
              v.addEventListener("DOMMouseScroll", E),
              A(),
              p
            );
          }),
            (this.removePin = function (e) {
              if (v) {
                if ((h === d && A(!0), e || !l)) {
                  var t = y.spacer.firstChild;
                  if (t.hasAttribute(N)) {
                    var n = y.spacer.style,
                      i = {};
                    [
                      "margin",
                      "marginLeft",
                      "marginRight",
                      "marginTop",
                      "marginBottom",
                    ].forEach(function (e) {
                      i[e] = n[e] || "";
                    }),
                      H.css(t, i);
                  }
                  y.spacer.parentNode.insertBefore(t, y.spacer),
                    y.spacer.parentNode.removeChild(y.spacer),
                    v.parentNode.hasAttribute(N) ||
                      (H.css(v, v.___origStyle), delete v.___origStyle);
                }
                window.removeEventListener("scroll", $),
                  window.removeEventListener("resize", $),
                  window.removeEventListener("resize", C),
                  v.removeEventListener("mousewheel", E),
                  v.removeEventListener("DOMMouseScroll", E),
                  (v = void 0);
              }
              return p;
            });
          var L,
            j = [];
          return (
            p.on("destroy.internal", function (e) {
              p.removeClassToggle(e.reset);
            }),
            (this.setClassToggle = function (e, t) {
              var n = H.get.elements(e);
              return (
                0 !== n.length &&
                  H.type.String(t) &&
                  (0 < j.length && p.removeClassToggle(),
                  (L = t),
                  (j = n),
                  p.on(
                    "enter.internal_class leave.internal_class",
                    function (e) {
                      var n = "enter" === e.type ? H.addClass : H.removeClass;
                      j.forEach(function (e, t) {
                        n(e, L);
                      });
                    }
                  )),
                p
              );
            }),
            (this.removeClassToggle = function (e) {
              return (
                e &&
                  j.forEach(function (e, t) {
                    H.removeClass(e, L);
                  }),
                p.off("start.internal_class end.internal_class"),
                (L = void 0),
                (j = []),
                p
              );
            }),
            (function () {
              for (var e in f) i.hasOwnProperty(e) || delete f[e];
              for (var t in i) r(t);
              T();
            })(),
            p
          );
        });
      var P = {
        defaults: {
          duration: 0,
          offset: 0,
          triggerElement: void 0,
          triggerHook: 0.5,
          reverse: !0,
          loglevel: 2,
        },
        validate: {
          offset: function (e) {
            if (((e = parseFloat(e)), !H.type.Number(e))) throw 0;
            return e;
          },
          triggerElement: function (e) {
            if ((e = e || void 0)) {
              var t = H.get.elements(e)[0];
              if (!t || !t.parentNode) throw 0;
              e = t;
            }
            return e;
          },
          triggerHook: function (e) {
            var t = {
              onCenter: 0.5,
              onEnter: 1,
              onLeave: 0,
            };
            if (H.type.Number(e)) e = Math.max(0, Math.min(parseFloat(e), 1));
            else {
              if (!(e in t)) throw 0;
              e = t[e];
            }
            return e;
          },
          reverse: function (e) {
            return !!e;
          },
        },
        shifts: ["duration", "offset", "triggerHook"],
      };
      (O.Scene.addOption = function (e, t, n, i) {
        e in P.defaults ||
          ((P.defaults[e] = t), (P.validate[e] = n), i && P.shifts.push(e));
      }),
        (O.Scene.extend = function (e) {
          var t = this;
          (O.Scene = function () {
            return (
              t.apply(this, arguments),
              (this.$super = H.extend({}, this)),
              e.apply(this, arguments) || this
            );
          }),
            H.extend(O.Scene, t),
            (O.Scene.prototype = t.prototype),
            (O.Scene.prototype.constructor = O.Scene);
        }),
        (O.Event = function (e, t, n, i) {
          for (var o in (i = i || {})) this[o] = i[o];
          return (
            (this.type = e),
            (this.target = this.currentTarget = n),
            (this.namespace = t || ""),
            (this.timeStamp = this.timestamp = Date.now()),
            this
          );
        });
      var H = (O._util = (function (s) {
        function a(e) {
          return parseFloat(e) || 0;
        }

        function l(e) {
          return e.currentStyle ? e.currentStyle : s.getComputedStyle(e);
        }

        function i(e, t, n, i) {
          if ((t = t === document ? s : t) === s) i = !1;
          else if (!u.DomElement(t)) return 0;
          e = e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
          var o =
            (n
              ? t["offset" + e] || t["outer" + e]
              : t["client" + e] || t["inner" + e]) || 0;
          if (n && i) {
            var r = l(t);
            o +=
              "Height" === e
                ? a(r.marginTop) + a(r.marginBottom)
                : a(r.marginLeft) + a(r.marginRight);
          }
          return o;
        }

        function c(e) {
          return e
            .replace(/^[^a-z]+([a-z])/g, "$1")
            .replace(/-([a-z])/g, function (e) {
              return e[1].toUpperCase();
            });
        }
        var n,
          e = {};
        (e.extend = function (e) {
          for (e = e || {}, n = 1; n < arguments.length; n++)
            if (arguments[n])
              for (var t in arguments[n])
                arguments[n].hasOwnProperty(t) && (e[t] = arguments[n][t]);
          return e;
        }),
          (e.isMarginCollapseType = function (e) {
            return (
              -1 <
              ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(e)
            );
          });
        var o = 0,
          t = ["ms", "moz", "webkit", "o"],
          r = s.requestAnimationFrame,
          d = s.cancelAnimationFrame;
        for (n = 0; !r && n < 4; ++n)
          (r = s[t[n] + "RequestAnimationFrame"]),
            (d =
              s[t[n] + "CancelAnimationFrame"] ||
              s[t[n] + "CancelRequestAnimationFrame"]);
        (r =
          r ||
          function (e) {
            var t = new Date().getTime(),
              n = Math.max(0, 16 - (t - o)),
              i = s.setTimeout(function () {
                e(t + n);
              }, n);
            return (o = t + n), i;
          }),
          (d =
            d ||
            function (e) {
              s.clearTimeout(e);
            }),
          (e.rAF = r.bind(s)),
          (e.cAF = d.bind(s));
        var u = (e.type = function (e) {
          return Object.prototype.toString
            .call(e)
            .replace(/^\[object (.+)\]$/, "$1")
            .toLowerCase();
        });
        (u.String = function (e) {
          return "string" === u(e);
        }),
          (u.Function = function (e) {
            return "function" === u(e);
          }),
          (u.Array = function (e) {
            return Array.isArray(e);
          }),
          (u.Number = function (e) {
            return !u.Array(e) && 0 <= e - parseFloat(e) + 1;
          }),
          (u.DomElement = function (e) {
            return "object" == typeof HTMLElement ||
              "function" == typeof HTMLElement
              ? e instanceof HTMLElement || e instanceof SVGElement
              : e &&
                  "object" == typeof e &&
                  null !== e &&
                  1 === e.nodeType &&
                  "string" == typeof e.nodeName;
          });
        var p = (e.get = {});
        return (
          (p.elements = function (e) {
            var t = [];
            if (u.String(e))
              try {
                e = document.querySelectorAll(e);
              } catch (e) {
                return t;
              }
            if ("nodelist" === u(e) || u.Array(e) || e instanceof NodeList)
              for (var n = 0, i = (t.length = e.length); n < i; n++) {
                var o = e[n];
                t[n] = u.DomElement(o) ? o : p.elements(o);
              }
            else (!u.DomElement(e) && e !== document && e !== s) || (t = [e]);
            return t;
          }),
          (p.scrollTop = function (e) {
            return e && "number" == typeof e.scrollTop
              ? e.scrollTop
              : s.pageYOffset || 0;
          }),
          (p.scrollLeft = function (e) {
            return e && "number" == typeof e.scrollLeft
              ? e.scrollLeft
              : s.pageXOffset || 0;
          }),
          (p.width = function (e, t, n) {
            return i("width", e, t, n);
          }),
          (p.height = function (e, t, n) {
            return i("height", e, t, n);
          }),
          (p.offset = function (e, t) {
            var n = {
              top: 0,
              left: 0,
            };
            if (e && e.getBoundingClientRect) {
              var i = e.getBoundingClientRect();
              (n.top = i.top),
                (n.left = i.left),
                t || ((n.top += p.scrollTop()), (n.left += p.scrollLeft()));
            }
            return n;
          }),
          (e.addClass = function (e, t) {
            t && (e.classList ? e.classList.add(t) : (e.className += " " + t));
          }),
          (e.removeClass = function (e, t) {
            t &&
              (e.classList
                ? e.classList.remove(t)
                : (e.className = e.className.replace(
                    RegExp(
                      "(^|\\b)" + t.split(" ").join("|") + "(\\b|$)",
                      "gi"
                    ),
                    " "
                  )));
          }),
          (e.css = function (e, t) {
            if (u.String(t)) return l(e)[c(t)];
            if (u.Array(t)) {
              var n = {},
                i = l(e);
              return (
                t.forEach(function (e, t) {
                  n[e] = i[c(e)];
                }),
                n
              );
            }
            for (var o in t) {
              var r = t[o];
              r == parseFloat(r) && (r += "px"), (e.style[c(o)] = r);
            }
          }),
          e
        );
      })(window || {}));
      return O;
    }),
    (function (e) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(["jquery"], e)
        : "undefined" != typeof exports
        ? (module.exports = e(require("jquery")))
        : e(jQuery);
    })(function (c) {
      "use strict";
      var o,
        s = window.Slick || {};
      (o = 0),
        ((s = function (e, t) {
          var n,
            i = this;
          (i.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: c(e),
            appendDots: c(e),
            arrows: !0,
            asNavFor: null,
            prevArrow:
              '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
            nextArrow:
              '<button class="slick-next" aria-label="Next" type="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function (e, t) {
              return c('<button type="button" />').text(t + 1);
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            focusOnChange: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3,
          }),
            (i.initials = {
              animating: !1,
              dragging: !1,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              scrolling: !1,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: !1,
              slideOffset: 0,
              swipeLeft: null,
              swiping: !1,
              $list: null,
              touchObject: {},
              transformsEnabled: !1,
              unslicked: !1,
            }),
            c.extend(i, i.initials),
            (i.activeBreakpoint = null),
            (i.animType = null),
            (i.animProp = null),
            (i.breakpoints = []),
            (i.breakpointSettings = []),
            (i.cssTransitions = !1),
            (i.focussed = !1),
            (i.interrupted = !1),
            (i.hidden = "hidden"),
            (i.paused = !0),
            (i.positionProp = null),
            (i.respondTo = null),
            (i.rowCount = 1),
            (i.shouldClick = !0),
            (i.$slider = c(e)),
            (i.$slidesCache = null),
            (i.transformType = null),
            (i.transitionType = null),
            (i.visibilityChange = "visibilitychange"),
            (i.windowWidth = 0),
            (i.windowTimer = null),
            (n = c(e).data("slick") || {}),
            (i.options = c.extend({}, i.defaults, t, n)),
            (i.currentSlide = i.options.initialSlide),
            (i.originalSettings = i.options),
            void 0 !== document.mozHidden
              ? ((i.hidden = "mozHidden"),
                (i.visibilityChange = "mozvisibilitychange"))
              : void 0 !== document.webkitHidden &&
                ((i.hidden = "webkitHidden"),
                (i.visibilityChange = "webkitvisibilitychange")),
            (i.autoPlay = c.proxy(i.autoPlay, i)),
            (i.autoPlayClear = c.proxy(i.autoPlayClear, i)),
            (i.autoPlayIterator = c.proxy(i.autoPlayIterator, i)),
            (i.changeSlide = c.proxy(i.changeSlide, i)),
            (i.clickHandler = c.proxy(i.clickHandler, i)),
            (i.selectHandler = c.proxy(i.selectHandler, i)),
            (i.setPosition = c.proxy(i.setPosition, i)),
            (i.swipeHandler = c.proxy(i.swipeHandler, i)),
            (i.dragHandler = c.proxy(i.dragHandler, i)),
            (i.keyHandler = c.proxy(i.keyHandler, i)),
            (i.instanceUid = o++),
            (i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
            i.registerBreakpoints(),
            i.init(!0);
        }).prototype.activateADA = function () {
          this.$slideTrack
            .find(".slick-active")
            .attr({
              "aria-hidden": "false",
            })
            .find("a, input, button, select")
            .attr({
              tabindex: "0",
            });
        }),
        (s.prototype.addSlide = s.prototype.slickAdd =
          function (e, t, n) {
            var i = this;
            if ("boolean" == typeof t) (n = t), (t = null);
            else if (t < 0 || t >= i.slideCount) return !1;
            i.unload(),
              "number" == typeof t
                ? 0 === t && 0 === i.$slides.length
                  ? c(e).appendTo(i.$slideTrack)
                  : n
                  ? c(e).insertBefore(i.$slides.eq(t))
                  : c(e).insertAfter(i.$slides.eq(t))
                : !0 === n
                ? c(e).prependTo(i.$slideTrack)
                : c(e).appendTo(i.$slideTrack),
              (i.$slides = i.$slideTrack.children(this.options.slide)),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.append(i.$slides),
              i.$slides.each(function (e, t) {
                c(t).attr("data-slick-index", e);
              }),
              (i.$slidesCache = i.$slides),
              i.reinit();
          }),
        (s.prototype.animateHeight = function () {
          var e = this;
          if (
            1 === e.options.slidesToShow &&
            !0 === e.options.adaptiveHeight &&
            !1 === e.options.vertical
          ) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.animate(
              {
                height: t,
              },
              e.options.speed
            );
          }
        }),
        (s.prototype.animateSlide = function (e, t) {
          var n = {},
            i = this;
          i.animateHeight(),
            !0 === i.options.rtl && !1 === i.options.vertical && (e = -e),
            !1 === i.transformsEnabled
              ? !1 === i.options.vertical
                ? i.$slideTrack.animate(
                    {
                      left: e,
                    },
                    i.options.speed,
                    i.options.easing,
                    t
                  )
                : i.$slideTrack.animate(
                    {
                      top: e,
                    },
                    i.options.speed,
                    i.options.easing,
                    t
                  )
              : !1 === i.cssTransitions
              ? (!0 === i.options.rtl && (i.currentLeft = -i.currentLeft),
                c({
                  animStart: i.currentLeft,
                }).animate(
                  {
                    animStart: e,
                  },
                  {
                    duration: i.options.speed,
                    easing: i.options.easing,
                    step: function (e) {
                      (e = Math.ceil(e)),
                        !1 === i.options.vertical
                          ? (n[i.animType] = "translate(" + e + "px, 0px)")
                          : (n[i.animType] = "translate(0px," + e + "px)"),
                        i.$slideTrack.css(n);
                    },
                    complete: function () {
                      t && t.call();
                    },
                  }
                ))
              : (i.applyTransition(),
                (e = Math.ceil(e)),
                !1 === i.options.vertical
                  ? (n[i.animType] = "translate3d(" + e + "px, 0px, 0px)")
                  : (n[i.animType] = "translate3d(0px," + e + "px, 0px)"),
                i.$slideTrack.css(n),
                t &&
                  setTimeout(function () {
                    i.disableTransition(), t.call();
                  }, i.options.speed));
        }),
        (s.prototype.getNavTarget = function () {
          var e = this.options.asNavFor;
          return e && null !== e && (e = c(e).not(this.$slider)), e;
        }),
        (s.prototype.asNavFor = function (t) {
          var e = this.getNavTarget();
          null !== e &&
            "object" == typeof e &&
            e.each(function () {
              var e = c(this).slick("getSlick");
              e.unslicked || e.slideHandler(t, !0);
            });
        }),
        (s.prototype.applyTransition = function (e) {
          var t = this,
            n = {};
          !1 === t.options.fade
            ? (n[t.transitionType] =
                t.transformType +
                " " +
                t.options.speed +
                "ms " +
                t.options.cssEase)
            : (n[t.transitionType] =
                "opacity " + t.options.speed + "ms " + t.options.cssEase),
            !1 === t.options.fade
              ? t.$slideTrack.css(n)
              : t.$slides.eq(e).css(n);
        }),
        (s.prototype.autoPlay = function () {
          var e = this;
          e.autoPlayClear(),
            e.slideCount > e.options.slidesToShow &&
              (e.autoPlayTimer = setInterval(
                e.autoPlayIterator,
                e.options.autoplaySpeed
              ));
        }),
        (s.prototype.autoPlayClear = function () {
          this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }),
        (s.prototype.autoPlayIterator = function () {
          var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
          e.paused ||
            e.interrupted ||
            e.focussed ||
            (!1 === e.options.infinite &&
              (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
                ? (e.direction = 0)
                : 0 === e.direction &&
                  ((t = e.currentSlide - e.options.slidesToScroll),
                  e.currentSlide - 1 == 0 && (e.direction = 1))),
            e.slideHandler(t));
        }),
        (s.prototype.buildArrows = function () {
          var e = this;
          !0 === e.options.arrows &&
            ((e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow")),
            (e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow")),
            e.slideCount > e.options.slidesToShow
              ? (e.$prevArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                e.$nextArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                e.htmlExpr.test(e.options.prevArrow) &&
                  e.$prevArrow.prependTo(e.options.appendArrows),
                e.htmlExpr.test(e.options.nextArrow) &&
                  e.$nextArrow.appendTo(e.options.appendArrows),
                !0 !== e.options.infinite &&
                  e.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"))
              : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                  "aria-disabled": "true",
                  tabindex: "-1",
                }));
        }),
        (s.prototype.buildDots = function () {
          var e,
            t,
            n = this;
          if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
            for (
              n.$slider.addClass("slick-dotted"),
                t = c("<ul />").addClass(n.options.dotsClass),
                e = 0;
              e <= n.getDotCount();
              e += 1
            )
              t.append(
                c("<li />").append(n.options.customPaging.call(this, n, e))
              );
            (n.$dots = t.appendTo(n.options.appendDots)),
              n.$dots.find("li").first().addClass("slick-active");
          }
        }),
        (s.prototype.buildOut = function () {
          var e = this;
          (e.$slides = e.$slider
            .children(e.options.slide + ":not(.slick-cloned)")
            .addClass("slick-slide")),
            (e.slideCount = e.$slides.length),
            e.$slides.each(function (e, t) {
              c(t)
                .attr("data-slick-index", e)
                .data("originalStyling", c(t).attr("style") || "");
            }),
            e.$slider.addClass("slick-slider"),
            (e.$slideTrack =
              0 === e.slideCount
                ? c('<div class="slick-track"/>').appendTo(e.$slider)
                : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
            (e.$list = e.$slideTrack
              .wrap('<div class="slick-list"/>')
              .parent()),
            e.$slideTrack.css("opacity", 0),
            (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
              (e.options.slidesToScroll = 1),
            c("img[data-lazy]", e.$slider)
              .not("[src]")
              .addClass("slick-loading"),
            e.setupInfinite(),
            e.buildArrows(),
            e.buildDots(),
            e.updateDots(),
            e.setSlideClasses(
              "number" == typeof e.currentSlide ? e.currentSlide : 0
            ),
            !0 === e.options.draggable && e.$list.addClass("draggable");
        }),
        (s.prototype.buildRows = function () {
          var e,
            t,
            n,
            i,
            o,
            r,
            s,
            a = this;
          if (
            ((i = document.createDocumentFragment()),
            (r = a.$slider.children()),
            0 < a.options.rows)
          ) {
            for (
              s = a.options.slidesPerRow * a.options.rows,
                o = Math.ceil(r.length / s),
                e = 0;
              e < o;
              e++
            ) {
              var l = document.createElement("div");
              for (t = 0; t < a.options.rows; t++) {
                var c = document.createElement("div");
                for (n = 0; n < a.options.slidesPerRow; n++) {
                  var d = e * s + (t * a.options.slidesPerRow + n);
                  r.get(d) && c.appendChild(r.get(d));
                }
                l.appendChild(c);
              }
              i.appendChild(l);
            }
            a.$slider.empty().append(i),
              a.$slider
                .children()
                .children()
                .children()
                .css({
                  width: 100 / a.options.slidesPerRow + "%",
                  display: "inline-block",
                });
          }
        }),
        (s.prototype.checkResponsive = function (e, t) {
          var n,
            i,
            o,
            r = this,
            s = !1,
            a = r.$slider.width(),
            l = window.innerWidth || c(window).width();
          if (
            ("window" === r.respondTo
              ? (o = l)
              : "slider" === r.respondTo
              ? (o = a)
              : "min" === r.respondTo && (o = Math.min(l, a)),
            r.options.responsive &&
              r.options.responsive.length &&
              null !== r.options.responsive)
          ) {
            for (n in ((i = null), r.breakpoints))
              r.breakpoints.hasOwnProperty(n) &&
                (!1 === r.originalSettings.mobileFirst
                  ? o < r.breakpoints[n] && (i = r.breakpoints[n])
                  : o > r.breakpoints[n] && (i = r.breakpoints[n]));
            null !== i
              ? (null !== r.activeBreakpoint &&
                  i === r.activeBreakpoint &&
                  !t) ||
                ((r.activeBreakpoint = i),
                "unslick" === r.breakpointSettings[i]
                  ? r.unslick(i)
                  : ((r.options = c.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[i]
                    )),
                    !0 === e && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (s = i))
              : null !== r.activeBreakpoint &&
                ((r.activeBreakpoint = null),
                (r.options = r.originalSettings),
                !0 === e && (r.currentSlide = r.options.initialSlide),
                r.refresh(e),
                (s = i)),
              e || !1 === s || r.$slider.trigger("breakpoint", [r, s]);
          }
        }),
        (s.prototype.changeSlide = function (e, t) {
          var n,
            i,
            o = this,
            r = c(e.currentTarget);
          switch (
            (r.is("a") && e.preventDefault(),
            r.is("li") || (r = r.closest("li")),
            (n =
              o.slideCount % o.options.slidesToScroll != 0
                ? 0
                : (o.slideCount - o.currentSlide) % o.options.slidesToScroll),
            e.data.message)
          ) {
            case "previous":
              (i =
                0 == n ? o.options.slidesToScroll : o.options.slidesToShow - n),
                o.slideCount > o.options.slidesToShow &&
                  o.slideHandler(o.currentSlide - i, !1, t);
              break;
            case "next":
              (i = 0 == n ? o.options.slidesToScroll : n),
                o.slideCount > o.options.slidesToShow &&
                  o.slideHandler(o.currentSlide + i, !1, t);
              break;
            case "index":
              var s =
                0 === e.data.index
                  ? 0
                  : e.data.index || r.index() * o.options.slidesToScroll;
              o.slideHandler(o.checkNavigable(s), !1, t),
                r.children().trigger("focus");
              break;
            default:
              return;
          }
        }),
        (s.prototype.checkNavigable = function (e) {
          var t, n;
          if (((n = 0), e > (t = this.getNavigableIndexes())[t.length - 1]))
            e = t[t.length - 1];
          else
            for (var i in t) {
              if (e < t[i]) {
                e = n;
                break;
              }
              n = t[i];
            }
          return e;
        }),
        (s.prototype.cleanUpEvents = function () {
          var e = this;
          e.options.dots &&
            null !== e.$dots &&
            (c("li", e.$dots)
              .off("click.slick", e.changeSlide)
              .off("mouseenter.slick", c.proxy(e.interrupt, e, !0))
              .off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
            !0 === e.options.accessibility &&
              e.$dots.off("keydown.slick", e.keyHandler)),
            e.$slider.off("focus.slick blur.slick"),
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
              e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
              !0 === e.options.accessibility &&
                (e.$prevArrow &&
                  e.$prevArrow.off("keydown.slick", e.keyHandler),
                e.$nextArrow &&
                  e.$nextArrow.off("keydown.slick", e.keyHandler))),
            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
            e.$list.off("click.slick", e.clickHandler),
            c(document).off(e.visibilityChange, e.visibility),
            e.cleanUpSlideEvents(),
            !0 === e.options.accessibility &&
              e.$list.off("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect &&
              c(e.$slideTrack).children().off("click.slick", e.selectHandler),
            c(window).off(
              "orientationchange.slick.slick-" + e.instanceUid,
              e.orientationChange
            ),
            c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
            c("[draggable!=true]", e.$slideTrack).off(
              "dragstart",
              e.preventDefault
            ),
            c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
        }),
        (s.prototype.cleanUpSlideEvents = function () {
          var e = this;
          e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
            e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1));
        }),
        (s.prototype.cleanUpRows = function () {
          var e;
          0 < this.options.rows &&
            ((e = this.$slides.children().children()).removeAttr("style"),
            this.$slider.empty().append(e));
        }),
        (s.prototype.clickHandler = function (e) {
          !1 === this.shouldClick &&
            (e.stopImmediatePropagation(),
            e.stopPropagation(),
            e.preventDefault());
        }),
        (s.prototype.destroy = function (e) {
          var t = this;
          t.autoPlayClear(),
            (t.touchObject = {}),
            t.cleanUpEvents(),
            c(".slick-cloned", t.$slider).detach(),
            t.$dots && t.$dots.remove(),
            t.$prevArrow &&
              t.$prevArrow.length &&
              (t.$prevArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
            t.$nextArrow &&
              t.$nextArrow.length &&
              (t.$nextArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
            t.$slides &&
              (t.$slides
                .removeClass(
                  "slick-slide slick-active slick-center slick-visible slick-current"
                )
                .removeAttr("aria-hidden")
                .removeAttr("data-slick-index")
                .each(function () {
                  c(this).attr("style", c(this).data("originalStyling"));
                }),
              t.$slideTrack.children(this.options.slide).detach(),
              t.$slideTrack.detach(),
              t.$list.detach(),
              t.$slider.append(t.$slides)),
            t.cleanUpRows(),
            t.$slider.removeClass("slick-slider"),
            t.$slider.removeClass("slick-initialized"),
            t.$slider.removeClass("slick-dotted"),
            (t.unslicked = !0),
            e || t.$slider.trigger("destroy", [t]);
        }),
        (s.prototype.disableTransition = function (e) {
          var t = {};
          (t[this.transitionType] = ""),
            !1 === this.options.fade
              ? this.$slideTrack.css(t)
              : this.$slides.eq(e).css(t);
        }),
        (s.prototype.fadeSlide = function (e, t) {
          var n = this;
          !1 === n.cssTransitions
            ? (n.$slides.eq(e).css({
                zIndex: n.options.zIndex,
              }),
              n.$slides.eq(e).animate(
                {
                  opacity: 1,
                },
                n.options.speed,
                n.options.easing,
                t
              ))
            : (n.applyTransition(e),
              n.$slides.eq(e).css({
                opacity: 1,
                zIndex: n.options.zIndex,
              }),
              t &&
                setTimeout(function () {
                  n.disableTransition(e), t.call();
                }, n.options.speed));
        }),
        (s.prototype.fadeSlideOut = function (e) {
          var t = this;
          !1 === t.cssTransitions
            ? t.$slides.eq(e).animate(
                {
                  opacity: 0,
                  zIndex: t.options.zIndex - 2,
                },
                t.options.speed,
                t.options.easing
              )
            : (t.applyTransition(e),
              t.$slides.eq(e).css({
                opacity: 0,
                zIndex: t.options.zIndex - 2,
              }));
        }),
        (s.prototype.filterSlides = s.prototype.slickFilter =
          function (e) {
            var t = this;
            null !== e &&
              ((t.$slidesCache = t.$slides),
              t.unload(),
              t.$slideTrack.children(this.options.slide).detach(),
              t.$slidesCache.filter(e).appendTo(t.$slideTrack),
              t.reinit());
          }),
        (s.prototype.focusHandler = function () {
          var n = this;
          n.$slider
            .off("focus.slick blur.slick")
            .on("focus.slick blur.slick", "*", function (e) {
              e.stopImmediatePropagation();
              var t = c(this);
              setTimeout(function () {
                n.options.pauseOnFocus &&
                  ((n.focussed = t.is(":focus")), n.autoPlay());
              }, 0);
            });
        }),
        (s.prototype.getCurrent = s.prototype.slickCurrentSlide =
          function () {
            return this.currentSlide;
          }),
        (s.prototype.getDotCount = function () {
          var e = this,
            t = 0,
            n = 0,
            i = 0;
          if (!0 === e.options.infinite)
            if (e.slideCount <= e.options.slidesToShow) ++i;
            else
              for (; t < e.slideCount; )
                ++i,
                  (t = n + e.options.slidesToScroll),
                  (n +=
                    e.options.slidesToScroll <= e.options.slidesToShow
                      ? e.options.slidesToScroll
                      : e.options.slidesToShow);
          else if (!0 === e.options.centerMode) i = e.slideCount;
          else if (e.options.asNavFor)
            for (; t < e.slideCount; )
              ++i,
                (t = n + e.options.slidesToScroll),
                (n +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
          else
            i =
              1 +
              Math.ceil(
                (e.slideCount - e.options.slidesToShow) /
                  e.options.slidesToScroll
              );
          return i - 1;
        }),
        (s.prototype.getLeft = function (e) {
          var t,
            n,
            i,
            o,
            r = this,
            s = 0;
          return (
            (r.slideOffset = 0),
            (n = r.$slides.first().outerHeight(!0)),
            !0 === r.options.infinite
              ? (r.slideCount > r.options.slidesToShow &&
                  ((r.slideOffset = r.slideWidth * r.options.slidesToShow * -1),
                  (o = -1),
                  !0 === r.options.vertical &&
                    !0 === r.options.centerMode &&
                    (2 === r.options.slidesToShow
                      ? (o = -1.5)
                      : 1 === r.options.slidesToShow && (o = -2)),
                  (s = n * r.options.slidesToShow * o)),
                r.slideCount % r.options.slidesToScroll != 0 &&
                  e + r.options.slidesToScroll > r.slideCount &&
                  r.slideCount > r.options.slidesToShow &&
                  (s =
                    e > r.slideCount
                      ? ((r.slideOffset =
                          (r.options.slidesToShow - (e - r.slideCount)) *
                          r.slideWidth *
                          -1),
                        (r.options.slidesToShow - (e - r.slideCount)) * n * -1)
                      : ((r.slideOffset =
                          (r.slideCount % r.options.slidesToScroll) *
                          r.slideWidth *
                          -1),
                        (r.slideCount % r.options.slidesToScroll) * n * -1)))
              : e + r.options.slidesToShow > r.slideCount &&
                ((r.slideOffset =
                  (e + r.options.slidesToShow - r.slideCount) * r.slideWidth),
                (s = (e + r.options.slidesToShow - r.slideCount) * n)),
            r.slideCount <= r.options.slidesToShow && (s = r.slideOffset = 0),
            !0 === r.options.centerMode &&
            r.slideCount <= r.options.slidesToShow
              ? (r.slideOffset =
                  (r.slideWidth * Math.floor(r.options.slidesToShow)) / 2 -
                  (r.slideWidth * r.slideCount) / 2)
              : !0 === r.options.centerMode && !0 === r.options.infinite
              ? (r.slideOffset +=
                  r.slideWidth * Math.floor(r.options.slidesToShow / 2) -
                  r.slideWidth)
              : !0 === r.options.centerMode &&
                ((r.slideOffset = 0),
                (r.slideOffset +=
                  r.slideWidth * Math.floor(r.options.slidesToShow / 2))),
            (t =
              !1 === r.options.vertical
                ? e * r.slideWidth * -1 + r.slideOffset
                : e * n * -1 + s),
            !0 === r.options.variableWidth &&
              ((i =
                r.slideCount <= r.options.slidesToShow ||
                !1 === r.options.infinite
                  ? r.$slideTrack.children(".slick-slide").eq(e)
                  : r.$slideTrack
                      .children(".slick-slide")
                      .eq(e + r.options.slidesToShow)),
              (t =
                !0 === r.options.rtl
                  ? i[0]
                    ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width())
                    : 0
                  : i[0]
                  ? -1 * i[0].offsetLeft
                  : 0),
              !0 === r.options.centerMode &&
                ((i =
                  r.slideCount <= r.options.slidesToShow ||
                  !1 === r.options.infinite
                    ? r.$slideTrack.children(".slick-slide").eq(e)
                    : r.$slideTrack
                        .children(".slick-slide")
                        .eq(e + r.options.slidesToShow + 1)),
                (t =
                  !0 === r.options.rtl
                    ? i[0]
                      ? -1 *
                        (r.$slideTrack.width() - i[0].offsetLeft - i.width())
                      : 0
                    : i[0]
                    ? -1 * i[0].offsetLeft
                    : 0),
                (t += (r.$list.width() - i.outerWidth()) / 2))),
            t
          );
        }),
        (s.prototype.getOption = s.prototype.slickGetOption =
          function (e) {
            return this.options[e];
          }),
        (s.prototype.getNavigableIndexes = function () {
          var e,
            t = this,
            n = 0,
            i = 0,
            o = [];
          for (
            e =
              !1 === t.options.infinite
                ? t.slideCount
                : ((n = -1 * t.options.slidesToScroll),
                  (i = -1 * t.options.slidesToScroll),
                  2 * t.slideCount);
            n < e;

          )
            o.push(n),
              (n = i + t.options.slidesToScroll),
              (i +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
          return o;
        }),
        (s.prototype.getSlick = function () {
          return this;
        }),
        (s.prototype.getSlideCount = function () {
          var n,
            i,
            o = this;
          return (
            (i =
              !0 === o.options.centerMode
                ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
                : 0),
            !0 === o.options.swipeToSlide
              ? (o.$slideTrack.find(".slick-slide").each(function (e, t) {
                  if (
                    t.offsetLeft - i + c(t).outerWidth() / 2 >
                    -1 * o.swipeLeft
                  )
                    return (n = t), !1;
                }),
                Math.abs(c(n).attr("data-slick-index") - o.currentSlide) || 1)
              : o.options.slidesToScroll
          );
        }),
        (s.prototype.goTo = s.prototype.slickGoTo =
          function (e, t) {
            this.changeSlide(
              {
                data: {
                  message: "index",
                  index: parseInt(e),
                },
              },
              t
            );
          }),
        (s.prototype.init = function (e) {
          var t = this;
          c(t.$slider).hasClass("slick-initialized") ||
            (c(t.$slider).addClass("slick-initialized"),
            t.buildRows(),
            t.buildOut(),
            t.setProps(),
            t.startLoad(),
            t.loadSlider(),
            t.initializeEvents(),
            t.updateArrows(),
            t.updateDots(),
            t.checkResponsive(!0),
            t.focusHandler()),
            e && t.$slider.trigger("init", [t]),
            !0 === t.options.accessibility && t.initADA(),
            t.options.autoplay && ((t.paused = !1), t.autoPlay());
        }),
        (s.prototype.initADA = function () {
          var i = this,
            n = Math.ceil(i.slideCount / i.options.slidesToShow),
            o = i.getNavigableIndexes().filter(function (e) {
              return 0 <= e && e < i.slideCount;
            });
          i.$slides
            .add(i.$slideTrack.find(".slick-cloned"))
            .attr({
              "aria-hidden": "true",
              tabindex: "-1",
            })
            .find("a, input, button, select")
            .attr({
              tabindex: "-1",
            }),
            null !== i.$dots &&
              (i.$slides
                .not(i.$slideTrack.find(".slick-cloned"))
                .each(function (e) {
                  var t = o.indexOf(e);
                  if (
                    (c(this).attr({
                      role: "tabpanel",
                      id: "slick-slide" + i.instanceUid + e,
                      tabindex: -1,
                    }),
                    -1 !== t)
                  ) {
                    var n = "slick-slide-control" + i.instanceUid + t;
                    c("#" + n).length &&
                      c(this).attr({
                        "aria-describedby": n,
                      });
                  }
                }),
              i.$dots
                .attr("role", "tablist")
                .find("li")
                .each(function (e) {
                  var t = o[e];
                  c(this).attr({
                    role: "presentation",
                  }),
                    c(this)
                      .find("button")
                      .first()
                      .attr({
                        role: "tab",
                        id: "slick-slide-control" + i.instanceUid + e,
                        "aria-controls": "slick-slide" + i.instanceUid + t,
                        "aria-label": e + 1 + " of " + n,
                        "aria-selected": null,
                        tabindex: "-1",
                      });
                })
                .eq(i.currentSlide)
                .find("button")
                .attr({
                  "aria-selected": "true",
                  tabindex: "0",
                })
                .end());
          for (
            var e = i.currentSlide, t = e + i.options.slidesToShow;
            e < t;
            e++
          )
            i.options.focusOnChange
              ? i.$slides.eq(e).attr({
                  tabindex: "0",
                })
              : i.$slides.eq(e).removeAttr("tabindex");
          i.activateADA();
        }),
        (s.prototype.initArrowEvents = function () {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.off("click.slick").on(
              "click.slick",
              {
                message: "previous",
              },
              e.changeSlide
            ),
            e.$nextArrow.off("click.slick").on(
              "click.slick",
              {
                message: "next",
              },
              e.changeSlide
            ),
            !0 === e.options.accessibility &&
              (e.$prevArrow.on("keydown.slick", e.keyHandler),
              e.$nextArrow.on("keydown.slick", e.keyHandler)));
        }),
        (s.prototype.initDotEvents = function () {
          var e = this;
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            (c("li", e.$dots).on(
              "click.slick",
              {
                message: "index",
              },
              e.changeSlide
            ),
            !0 === e.options.accessibility &&
              e.$dots.on("keydown.slick", e.keyHandler)),
            !0 === e.options.dots &&
              !0 === e.options.pauseOnDotsHover &&
              e.slideCount > e.options.slidesToShow &&
              c("li", e.$dots)
                .on("mouseenter.slick", c.proxy(e.interrupt, e, !0))
                .on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
        }),
        (s.prototype.initSlideEvents = function () {
          var e = this;
          e.options.pauseOnHover &&
            (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
            e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)));
        }),
        (s.prototype.initializeEvents = function () {
          var e = this;
          e.initArrowEvents(),
            e.initDotEvents(),
            e.initSlideEvents(),
            e.$list.on(
              "touchstart.slick mousedown.slick",
              {
                action: "start",
              },
              e.swipeHandler
            ),
            e.$list.on(
              "touchmove.slick mousemove.slick",
              {
                action: "move",
              },
              e.swipeHandler
            ),
            e.$list.on(
              "touchend.slick mouseup.slick",
              {
                action: "end",
              },
              e.swipeHandler
            ),
            e.$list.on(
              "touchcancel.slick mouseleave.slick",
              {
                action: "end",
              },
              e.swipeHandler
            ),
            e.$list.on("click.slick", e.clickHandler),
            c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
            !0 === e.options.accessibility &&
              e.$list.on("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect &&
              c(e.$slideTrack).children().on("click.slick", e.selectHandler),
            c(window).on(
              "orientationchange.slick.slick-" + e.instanceUid,
              c.proxy(e.orientationChange, e)
            ),
            c(window).on(
              "resize.slick.slick-" + e.instanceUid,
              c.proxy(e.resize, e)
            ),
            c("[draggable!=true]", e.$slideTrack).on(
              "dragstart",
              e.preventDefault
            ),
            c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
            c(e.setPosition);
        }),
        (s.prototype.initUI = function () {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.show(), e.$nextArrow.show()),
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              e.$dots.show();
        }),
        (s.prototype.keyHandler = function (e) {
          var t = this;
          e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
            (37 === e.keyCode && !0 === t.options.accessibility
              ? t.changeSlide({
                  data: {
                    message: !0 === t.options.rtl ? "next" : "previous",
                  },
                })
              : 39 === e.keyCode &&
                !0 === t.options.accessibility &&
                t.changeSlide({
                  data: {
                    message: !0 === t.options.rtl ? "previous" : "next",
                  },
                }));
        }),
        (s.prototype.lazyLoad = function () {
          var e,
            t,
            n,
            r = this;

          function i(e) {
            c("img[data-lazy]", e).each(function () {
              var e = c(this),
                t = c(this).attr("data-lazy"),
                n = c(this).attr("data-srcset"),
                i = c(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
                o = document.createElement("img");
              (o.onload = function () {
                e.animate(
                  {
                    opacity: 0,
                  },
                  100,
                  function () {
                    n && (e.attr("srcset", n), i && e.attr("sizes", i)),
                      e.attr("src", t).animate(
                        {
                          opacity: 1,
                        },
                        200,
                        function () {
                          e.removeAttr(
                            "data-lazy data-srcset data-sizes"
                          ).removeClass("slick-loading");
                        }
                      ),
                      r.$slider.trigger("lazyLoaded", [r, e, t]);
                  }
                );
              }),
                (o.onerror = function () {
                  e
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                    r.$slider.trigger("lazyLoadError", [r, e, t]);
                }),
                (o.src = t);
            });
          }
          if (
            (!0 === r.options.centerMode
              ? (n =
                  !0 === r.options.infinite
                    ? (t = r.currentSlide + (r.options.slidesToShow / 2 + 1)) +
                      r.options.slidesToShow +
                      2
                    : ((t = Math.max(
                        0,
                        r.currentSlide - (r.options.slidesToShow / 2 + 1)
                      )),
                      r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide))
              : ((t = r.options.infinite
                  ? r.options.slidesToShow + r.currentSlide
                  : r.currentSlide),
                (n = Math.ceil(t + r.options.slidesToShow)),
                !0 === r.options.fade &&
                  (0 < t && t--, n <= r.slideCount && n++)),
            (e = r.$slider.find(".slick-slide").slice(t, n)),
            "anticipated" === r.options.lazyLoad)
          )
            for (
              var o = t - 1, s = n, a = r.$slider.find(".slick-slide"), l = 0;
              l < r.options.slidesToScroll;
              l++
            )
              o < 0 && (o = r.slideCount - 1),
                (e = (e = e.add(a.eq(o))).add(a.eq(s))),
                o--,
                s++;
          i(e),
            r.slideCount <= r.options.slidesToShow
              ? i(r.$slider.find(".slick-slide"))
              : r.currentSlide >= r.slideCount - r.options.slidesToShow
              ? i(
                  r.$slider
                    .find(".slick-cloned")
                    .slice(0, r.options.slidesToShow)
                )
              : 0 === r.currentSlide &&
                i(
                  r.$slider
                    .find(".slick-cloned")
                    .slice(-1 * r.options.slidesToShow)
                );
        }),
        (s.prototype.loadSlider = function () {
          var e = this;
          e.setPosition(),
            e.$slideTrack.css({
              opacity: 1,
            }),
            e.$slider.removeClass("slick-loading"),
            e.initUI(),
            "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
        }),
        (s.prototype.next = s.prototype.slickNext =
          function () {
            this.changeSlide({
              data: {
                message: "next",
              },
            });
          }),
        (s.prototype.orientationChange = function () {
          this.checkResponsive(), this.setPosition();
        }),
        (s.prototype.pause = s.prototype.slickPause =
          function () {
            this.autoPlayClear(), (this.paused = !0);
          }),
        (s.prototype.play = s.prototype.slickPlay =
          function () {
            var e = this;
            e.autoPlay(),
              (e.options.autoplay = !0),
              (e.paused = !1),
              (e.focussed = !1),
              (e.interrupted = !1);
          }),
        (s.prototype.postSlide = function (e) {
          var t = this;
          t.unslicked ||
            (t.$slider.trigger("afterChange", [t, e]),
            (t.animating = !1),
            t.slideCount > t.options.slidesToShow && t.setPosition(),
            (t.swipeLeft = null),
            t.options.autoplay && t.autoPlay(),
            !0 === t.options.accessibility &&
              (t.initADA(),
              t.options.focusOnChange &&
                c(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
        }),
        (s.prototype.prev = s.prototype.slickPrev =
          function () {
            this.changeSlide({
              data: {
                message: "previous",
              },
            });
          }),
        (s.prototype.preventDefault = function (e) {
          e.preventDefault();
        }),
        (s.prototype.progressiveLazyLoad = function (e) {
          e = e || 1;
          var t,
            n,
            i,
            o,
            r,
            s = this,
            a = c("img[data-lazy]", s.$slider);
          a.length
            ? ((t = a.first()),
              (n = t.attr("data-lazy")),
              (i = t.attr("data-srcset")),
              (o = t.attr("data-sizes") || s.$slider.attr("data-sizes")),
              ((r = document.createElement("img")).onload = function () {
                i && (t.attr("srcset", i), o && t.attr("sizes", o)),
                  t
                    .attr("src", n)
                    .removeAttr("data-lazy data-srcset data-sizes")
                    .removeClass("slick-loading"),
                  !0 === s.options.adaptiveHeight && s.setPosition(),
                  s.$slider.trigger("lazyLoaded", [s, t, n]),
                  s.progressiveLazyLoad();
              }),
              (r.onerror = function () {
                e < 3
                  ? setTimeout(function () {
                      s.progressiveLazyLoad(e + 1);
                    }, 500)
                  : (t
                      .removeAttr("data-lazy")
                      .removeClass("slick-loading")
                      .addClass("slick-lazyload-error"),
                    s.$slider.trigger("lazyLoadError", [s, t, n]),
                    s.progressiveLazyLoad());
              }),
              (r.src = n))
            : s.$slider.trigger("allImagesLoaded", [s]);
        }),
        (s.prototype.refresh = function (e) {
          var t,
            n,
            i = this;
          (n = i.slideCount - i.options.slidesToShow),
            !i.options.infinite && i.currentSlide > n && (i.currentSlide = n),
            i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
            (t = i.currentSlide),
            i.destroy(!0),
            c.extend(i, i.initials, {
              currentSlide: t,
            }),
            i.init(),
            e ||
              i.changeSlide(
                {
                  data: {
                    message: "index",
                    index: t,
                  },
                },
                !1
              );
        }),
        (s.prototype.registerBreakpoints = function () {
          var e,
            t,
            n,
            i = this,
            o = i.options.responsive || null;
          if ("array" === c.type(o) && o.length) {
            for (e in ((i.respondTo = i.options.respondTo || "window"), o))
              if (((n = i.breakpoints.length - 1), o.hasOwnProperty(e))) {
                for (t = o[e].breakpoint; 0 <= n; )
                  i.breakpoints[n] &&
                    i.breakpoints[n] === t &&
                    i.breakpoints.splice(n, 1),
                    n--;
                i.breakpoints.push(t),
                  (i.breakpointSettings[t] = o[e].settings);
              }
            i.breakpoints.sort(function (e, t) {
              return i.options.mobileFirst ? e - t : t - e;
            });
          }
        }),
        (s.prototype.reinit = function () {
          var e = this;
          (e.$slides = e.$slideTrack
            .children(e.options.slide)
            .addClass("slick-slide")),
            (e.slideCount = e.$slides.length),
            e.currentSlide >= e.slideCount &&
              0 !== e.currentSlide &&
              (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
            e.registerBreakpoints(),
            e.setProps(),
            e.setupInfinite(),
            e.buildArrows(),
            e.updateArrows(),
            e.initArrowEvents(),
            e.buildDots(),
            e.updateDots(),
            e.initDotEvents(),
            e.cleanUpSlideEvents(),
            e.initSlideEvents(),
            e.checkResponsive(!1, !0),
            !0 === e.options.focusOnSelect &&
              c(e.$slideTrack).children().on("click.slick", e.selectHandler),
            e.setSlideClasses(
              "number" == typeof e.currentSlide ? e.currentSlide : 0
            ),
            e.setPosition(),
            e.focusHandler(),
            (e.paused = !e.options.autoplay),
            e.autoPlay(),
            e.$slider.trigger("reInit", [e]);
        }),
        (s.prototype.resize = function () {
          var e = this;
          c(window).width() !== e.windowWidth &&
            (clearTimeout(e.windowDelay),
            (e.windowDelay = window.setTimeout(function () {
              (e.windowWidth = c(window).width()),
                e.checkResponsive(),
                e.unslicked || e.setPosition();
            }, 50)));
        }),
        (s.prototype.removeSlide = s.prototype.slickRemove =
          function (e, t, n) {
            var i = this;
            if (
              ((e =
                "boolean" == typeof e
                  ? !0 === (t = e)
                    ? 0
                    : i.slideCount - 1
                  : !0 === t
                  ? --e
                  : e),
              i.slideCount < 1 || e < 0 || e > i.slideCount - 1)
            )
              return !1;
            i.unload(),
              !0 === n
                ? i.$slideTrack.children().remove()
                : i.$slideTrack.children(this.options.slide).eq(e).remove(),
              (i.$slides = i.$slideTrack.children(this.options.slide)),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.append(i.$slides),
              (i.$slidesCache = i.$slides),
              i.reinit();
          }),
        (s.prototype.setCSS = function (e) {
          var t,
            n,
            i = this,
            o = {};
          !0 === i.options.rtl && (e = -e),
            (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
            (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
            (o[i.positionProp] = e),
            !1 === i.transformsEnabled ||
              (!(o = {}) === i.cssTransitions
                ? (o[i.animType] = "translate(" + t + ", " + n + ")")
                : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)")),
            i.$slideTrack.css(o);
        }),
        (s.prototype.setDimensions = function () {
          var e = this;
          !1 === e.options.vertical
            ? !0 === e.options.centerMode &&
              e.$list.css({
                padding: "0px " + e.options.centerPadding,
              })
            : (e.$list.height(
                e.$slides.first().outerHeight(!0) * e.options.slidesToShow
              ),
              !0 === e.options.centerMode &&
                e.$list.css({
                  padding: e.options.centerPadding + " 0px",
                })),
            (e.listWidth = e.$list.width()),
            (e.listHeight = e.$list.height()),
            !1 === e.options.vertical && !1 === e.options.variableWidth
              ? ((e.slideWidth = Math.ceil(
                  e.listWidth / e.options.slidesToShow
                )),
                e.$slideTrack.width(
                  Math.ceil(
                    e.slideWidth * e.$slideTrack.children(".slick-slide").length
                  )
                ))
              : !0 === e.options.variableWidth
              ? e.$slideTrack.width(5e3 * e.slideCount)
              : ((e.slideWidth = Math.ceil(e.listWidth)),
                e.$slideTrack.height(
                  Math.ceil(
                    e.$slides.first().outerHeight(!0) *
                      e.$slideTrack.children(".slick-slide").length
                  )
                ));
          var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
          !1 === e.options.variableWidth &&
            e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
        }),
        (s.prototype.setFade = function () {
          var n,
            i = this;
          i.$slides.each(function (e, t) {
            (n = i.slideWidth * e * -1),
              !0 === i.options.rtl
                ? c(t).css({
                    position: "relative",
                    right: n,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0,
                  })
                : c(t).css({
                    position: "relative",
                    left: n,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0,
                  });
          }),
            i.$slides.eq(i.currentSlide).css({
              zIndex: i.options.zIndex - 1,
              opacity: 1,
            });
        }),
        (s.prototype.setHeight = function () {
          var e = this;
          if (
            1 === e.options.slidesToShow &&
            !0 === e.options.adaptiveHeight &&
            !1 === e.options.vertical
          ) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.css("height", t);
          }
        }),
        (s.prototype.setOption = s.prototype.slickSetOption =
          function () {
            var e,
              t,
              n,
              i,
              o,
              r = this,
              s = !1;
            if (
              ("object" === c.type(arguments[0])
                ? ((n = arguments[0]), (s = arguments[1]), (o = "multiple"))
                : "string" === c.type(arguments[0]) &&
                  ((i = arguments[1]),
                  (s = arguments[2]),
                  "responsive" === (n = arguments[0]) &&
                  "array" === c.type(arguments[1])
                    ? (o = "responsive")
                    : void 0 !== arguments[1] && (o = "single")),
              "single" === o)
            )
              r.options[n] = i;
            else if ("multiple" === o)
              c.each(n, function (e, t) {
                r.options[e] = t;
              });
            else if ("responsive" === o)
              for (t in i)
                if ("array" !== c.type(r.options.responsive))
                  r.options.responsive = [i[t]];
                else {
                  for (e = r.options.responsive.length - 1; 0 <= e; )
                    r.options.responsive[e].breakpoint === i[t].breakpoint &&
                      r.options.responsive.splice(e, 1),
                      e--;
                  r.options.responsive.push(i[t]);
                }
            s && (r.unload(), r.reinit());
          }),
        (s.prototype.setPosition = function () {
          var e = this;
          e.setDimensions(),
            e.setHeight(),
            !1 === e.options.fade
              ? e.setCSS(e.getLeft(e.currentSlide))
              : e.setFade(),
            e.$slider.trigger("setPosition", [e]);
        }),
        (s.prototype.setProps = function () {
          var e = this,
            t = document.body.style;
          (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
            "top" === e.positionProp
              ? e.$slider.addClass("slick-vertical")
              : e.$slider.removeClass("slick-vertical"),
            (void 0 === t.WebkitTransition &&
              void 0 === t.MozTransition &&
              void 0 === t.msTransition) ||
              (!0 === e.options.useCSS && (e.cssTransitions = !0)),
            e.options.fade &&
              ("number" == typeof e.options.zIndex
                ? e.options.zIndex < 3 && (e.options.zIndex = 3)
                : (e.options.zIndex = e.defaults.zIndex)),
            void 0 !== t.OTransform &&
              ((e.animType = "OTransform"),
              (e.transformType = "-o-transform"),
              (e.transitionType = "OTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.webkitPerspective &&
                (e.animType = !1)),
            void 0 !== t.MozTransform &&
              ((e.animType = "MozTransform"),
              (e.transformType = "-moz-transform"),
              (e.transitionType = "MozTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.MozPerspective &&
                (e.animType = !1)),
            void 0 !== t.webkitTransform &&
              ((e.animType = "webkitTransform"),
              (e.transformType = "-webkit-transform"),
              (e.transitionType = "webkitTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.webkitPerspective &&
                (e.animType = !1)),
            void 0 !== t.msTransform &&
              ((e.animType = "msTransform"),
              (e.transformType = "-ms-transform"),
              (e.transitionType = "msTransition"),
              void 0 === t.msTransform && (e.animType = !1)),
            void 0 !== t.transform &&
              !1 !== e.animType &&
              ((e.animType = "transform"),
              (e.transformType = "transform"),
              (e.transitionType = "transition")),
            (e.transformsEnabled =
              e.options.useTransform &&
              null !== e.animType &&
              !1 !== e.animType);
        }),
        (s.prototype.setSlideClasses = function (e) {
          var t,
            n,
            i,
            o,
            r = this;
          if (
            ((n = r.$slider
              .find(".slick-slide")
              .removeClass("slick-active slick-center slick-current")
              .attr("aria-hidden", "true")),
            r.$slides.eq(e).addClass("slick-current"),
            !0 === r.options.centerMode)
          ) {
            var s = r.options.slidesToShow % 2 == 0 ? 1 : 0;
            (t = Math.floor(r.options.slidesToShow / 2)),
              !0 === r.options.infinite &&
                (t <= e && e <= r.slideCount - 1 - t
                  ? r.$slides
                      .slice(e - t + s, e + t + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((i = r.options.slidesToShow + e),
                    n
                      .slice(i - t + 1 + s, i + t + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === e
                  ? n
                      .eq(n.length - 1 - r.options.slidesToShow)
                      .addClass("slick-center")
                  : e === r.slideCount - 1 &&
                    n.eq(r.options.slidesToShow).addClass("slick-center")),
              r.$slides.eq(e).addClass("slick-center");
          } else
            0 <= e && e <= r.slideCount - r.options.slidesToShow
              ? r.$slides
                  .slice(e, e + r.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : n.length <= r.options.slidesToShow
              ? n.addClass("slick-active").attr("aria-hidden", "false")
              : ((o = r.slideCount % r.options.slidesToShow),
                (i =
                  !0 === r.options.infinite ? r.options.slidesToShow + e : e),
                r.options.slidesToShow == r.options.slidesToScroll &&
                r.slideCount - e < r.options.slidesToShow
                  ? n
                      .slice(i - (r.options.slidesToShow - o), i + o)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : n
                      .slice(i, i + r.options.slidesToShow)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false"));
          ("ondemand" !== r.options.lazyLoad &&
            "anticipated" !== r.options.lazyLoad) ||
            r.lazyLoad();
        }),
        (s.prototype.setupInfinite = function () {
          var e,
            t,
            n,
            i = this;
          if (
            (!0 === i.options.fade && (i.options.centerMode = !1),
            !0 === i.options.infinite &&
              !1 === i.options.fade &&
              ((t = null), i.slideCount > i.options.slidesToShow))
          ) {
            for (
              n =
                !0 === i.options.centerMode
                  ? i.options.slidesToShow + 1
                  : i.options.slidesToShow,
                e = i.slideCount;
              e > i.slideCount - n;
              e -= 1
            )
              (t = e - 1),
                c(i.$slides[t])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", t - i.slideCount)
                  .prependTo(i.$slideTrack)
                  .addClass("slick-cloned");
            for (e = 0; e < n + i.slideCount; e += 1)
              (t = e),
                c(i.$slides[t])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", t + i.slideCount)
                  .appendTo(i.$slideTrack)
                  .addClass("slick-cloned");
            i.$slideTrack
              .find(".slick-cloned")
              .find("[id]")
              .each(function () {
                c(this).attr("id", "");
              });
          }
        }),
        (s.prototype.interrupt = function (e) {
          e || this.autoPlay(), (this.interrupted = e);
        }),
        (s.prototype.selectHandler = function (e) {
          var t = c(e.target).is(".slick-slide")
              ? c(e.target)
              : c(e.target).parents(".slick-slide"),
            n = parseInt(t.attr("data-slick-index"));
          (n = n || 0),
            this.slideCount <= this.options.slidesToShow
              ? this.slideHandler(n, !1, !0)
              : this.slideHandler(n);
        }),
        (s.prototype.slideHandler = function (e, t, n) {
          var i,
            o,
            r,
            s,
            a,
            l,
            c = this;
          if (
            ((t = t || !1),
            !(
              (!0 === c.animating && !0 === c.options.waitForAnimate) ||
              (!0 === c.options.fade && c.currentSlide === e)
            ))
          )
            if (
              (!1 === t && c.asNavFor(e),
              (i = e),
              (a = c.getLeft(i)),
              (s = c.getLeft(c.currentSlide)),
              (c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft),
              !1 === c.options.infinite &&
                !1 === c.options.centerMode &&
                (e < 0 || e > c.getDotCount() * c.options.slidesToScroll))
            )
              !1 === c.options.fade &&
                ((i = c.currentSlide),
                !0 !== n && c.slideCount > c.options.slidesToShow
                  ? c.animateSlide(s, function () {
                      c.postSlide(i);
                    })
                  : c.postSlide(i));
            else if (
              !1 === c.options.infinite &&
              !0 === c.options.centerMode &&
              (e < 0 || e > c.slideCount - c.options.slidesToScroll)
            )
              !1 === c.options.fade &&
                ((i = c.currentSlide),
                !0 !== n && c.slideCount > c.options.slidesToShow
                  ? c.animateSlide(s, function () {
                      c.postSlide(i);
                    })
                  : c.postSlide(i));
            else {
              if (
                (c.options.autoplay && clearInterval(c.autoPlayTimer),
                (o =
                  i < 0
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                      : c.slideCount + i
                    : i >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? 0
                      : i - c.slideCount
                    : i),
                (c.animating = !0),
                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                (r = c.currentSlide),
                (c.currentSlide = o),
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor &&
                  (l = (l = c.getNavTarget()).slick("getSlick")).slideCount <=
                    l.options.slidesToShow &&
                  l.setSlideClasses(c.currentSlide),
                c.updateDots(),
                c.updateArrows(),
                !0 === c.options.fade)
              )
                return (
                  !0 !== n
                    ? (c.fadeSlideOut(r),
                      c.fadeSlide(o, function () {
                        c.postSlide(o);
                      }))
                    : c.postSlide(o),
                  void c.animateHeight()
                );
              !0 !== n && c.slideCount > c.options.slidesToShow
                ? c.animateSlide(a, function () {
                    c.postSlide(o);
                  })
                : c.postSlide(o);
            }
        }),
        (s.prototype.startLoad = function () {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.hide(), e.$nextArrow.hide()),
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              e.$dots.hide(),
            e.$slider.addClass("slick-loading");
        }),
        (s.prototype.swipeDirection = function () {
          var e,
            t,
            n,
            i,
            o = this;
          return (
            (e = o.touchObject.startX - o.touchObject.curX),
            (t = o.touchObject.startY - o.touchObject.curY),
            (n = Math.atan2(t, e)),
            (i = Math.round((180 * n) / Math.PI)) < 0 &&
              (i = 360 - Math.abs(i)),
            i <= 45 && 0 <= i
              ? !1 === o.options.rtl
                ? "left"
                : "right"
              : i <= 360 && 315 <= i
              ? !1 === o.options.rtl
                ? "left"
                : "right"
              : 135 <= i && i <= 225
              ? !1 === o.options.rtl
                ? "right"
                : "left"
              : !0 === o.options.verticalSwiping
              ? 35 <= i && i <= 135
                ? "down"
                : "up"
              : "vertical"
          );
        }),
        (s.prototype.swipeEnd = function (e) {
          var t,
            n,
            i = this;
          if (((i.dragging = !1), (i.swiping = !1), i.scrolling))
            return (i.scrolling = !1);
          if (
            ((i.interrupted = !1),
            (i.shouldClick = !(10 < i.touchObject.swipeLength)),
            void 0 === i.touchObject.curX)
          )
            return !1;
          if (
            (!0 === i.touchObject.edgeHit &&
              i.$slider.trigger("edge", [i, i.swipeDirection()]),
            i.touchObject.swipeLength >= i.touchObject.minSwipe)
          ) {
            switch ((n = i.swipeDirection())) {
              case "left":
              case "down":
                (t = i.options.swipeToSlide
                  ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                  : i.currentSlide + i.getSlideCount()),
                  (i.currentDirection = 0);
                break;
              case "right":
              case "up":
                (t = i.options.swipeToSlide
                  ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                  : i.currentSlide - i.getSlideCount()),
                  (i.currentDirection = 1);
            }
            "vertical" != n &&
              (i.slideHandler(t),
              (i.touchObject = {}),
              i.$slider.trigger("swipe", [i, n]));
          } else
            i.touchObject.startX !== i.touchObject.curX &&
              (i.slideHandler(i.currentSlide), (i.touchObject = {}));
        }),
        (s.prototype.swipeHandler = function (e) {
          var t = this;
          if (
            !(
              !1 === t.options.swipe ||
              ("ontouchend" in document && !1 === t.options.swipe) ||
              (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
            )
          )
            switch (
              ((t.touchObject.fingerCount =
                e.originalEvent && void 0 !== e.originalEvent.touches
                  ? e.originalEvent.touches.length
                  : 1),
              (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
              !0 === t.options.verticalSwiping &&
                (t.touchObject.minSwipe =
                  t.listHeight / t.options.touchThreshold),
              e.data.action)
            ) {
              case "start":
                t.swipeStart(e);
                break;
              case "move":
                t.swipeMove(e);
                break;
              case "end":
                t.swipeEnd(e);
            }
        }),
        (s.prototype.swipeMove = function (e) {
          var t,
            n,
            i,
            o,
            r,
            s,
            a = this;
          return (
            (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
            !(!a.dragging || a.scrolling || (r && 1 !== r.length)) &&
              ((t = a.getLeft(a.currentSlide)),
              (a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
              (a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
              (a.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(a.touchObject.curX - a.touchObject.startX, 2)
                )
              )),
              (s = Math.round(
                Math.sqrt(
                  Math.pow(a.touchObject.curY - a.touchObject.startY, 2)
                )
              )),
              !a.options.verticalSwiping && !a.swiping && 4 < s
                ? !(a.scrolling = !0)
                : (!0 === a.options.verticalSwiping &&
                    (a.touchObject.swipeLength = s),
                  (n = a.swipeDirection()),
                  void 0 !== e.originalEvent &&
                    4 < a.touchObject.swipeLength &&
                    ((a.swiping = !0), e.preventDefault()),
                  (o =
                    (!1 === a.options.rtl ? 1 : -1) *
                    (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                  !0 === a.options.verticalSwiping &&
                    (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
                  (i = a.touchObject.swipeLength),
                  (a.touchObject.edgeHit = !1) === a.options.infinite &&
                    ((0 === a.currentSlide && "right" === n) ||
                      (a.currentSlide >= a.getDotCount() && "left" === n)) &&
                    ((i = a.touchObject.swipeLength * a.options.edgeFriction),
                    (a.touchObject.edgeHit = !0)),
                  !1 === a.options.vertical
                    ? (a.swipeLeft = t + i * o)
                    : (a.swipeLeft =
                        t + i * (a.$list.height() / a.listWidth) * o),
                  !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * o),
                  !0 !== a.options.fade &&
                    !1 !== a.options.touchMove &&
                    (!0 === a.animating
                      ? ((a.swipeLeft = null), !1)
                      : void a.setCSS(a.swipeLeft))))
          );
        }),
        (s.prototype.swipeStart = function (e) {
          var t,
            n = this;
          if (
            ((n.interrupted = !0),
            1 !== n.touchObject.fingerCount ||
              n.slideCount <= n.options.slidesToShow)
          )
            return !(n.touchObject = {});
          void 0 !== e.originalEvent &&
            void 0 !== e.originalEvent.touches &&
            (t = e.originalEvent.touches[0]),
            (n.touchObject.startX = n.touchObject.curX =
              void 0 !== t ? t.pageX : e.clientX),
            (n.touchObject.startY = n.touchObject.curY =
              void 0 !== t ? t.pageY : e.clientY),
            (n.dragging = !0);
        }),
        (s.prototype.unfilterSlides = s.prototype.slickUnfilter =
          function () {
            var e = this;
            null !== e.$slidesCache &&
              (e.unload(),
              e.$slideTrack.children(this.options.slide).detach(),
              e.$slidesCache.appendTo(e.$slideTrack),
              e.reinit());
          }),
        (s.prototype.unload = function () {
          var e = this;
          c(".slick-cloned", e.$slider).remove(),
            e.$dots && e.$dots.remove(),
            e.$prevArrow &&
              e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.remove(),
            e.$nextArrow &&
              e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.remove(),
            e.$slides
              .removeClass(
                "slick-slide slick-active slick-visible slick-current"
              )
              .attr("aria-hidden", "true")
              .css("width", "");
        }),
        (s.prototype.unslick = function (e) {
          this.$slider.trigger("unslick", [this, e]), this.destroy();
        }),
        (s.prototype.updateArrows = function () {
          var e = this;
          Math.floor(e.options.slidesToShow / 2),
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              !e.options.infinite &&
              (e.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              e.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              0 === e.currentSlide
                ? (e.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$nextArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                  !1 === e.options.centerMode
                ? (e.$nextArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : e.currentSlide >= e.slideCount - 1 &&
                  !0 === e.options.centerMode &&
                  (e.$nextArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false")));
        }),
        (s.prototype.updateDots = function () {
          var e = this;
          null !== e.$dots &&
            (e.$dots.find("li").removeClass("slick-active").end(),
            e.$dots
              .find("li")
              .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
              .addClass("slick-active"));
        }),
        (s.prototype.visibility = function () {
          this.options.autoplay &&
            (document[this.hidden]
              ? (this.interrupted = !0)
              : (this.interrupted = !1));
        }),
        (c.fn.slick = function () {
          var e,
            t,
            n = this,
            i = arguments[0],
            o = Array.prototype.slice.call(arguments, 1),
            r = n.length;
          for (e = 0; e < r; e++)
            if (
              ("object" == typeof i || void 0 === i
                ? (n[e].slick = new s(n[e], i))
                : (t = n[e].slick[i].apply(n[e].slick, o)),
              void 0 !== t)
            )
              return t;
          return n;
        });
    }),
    $(document).ready(function () {
      if ($(".integrations-wrapper").length > 0) {
        var e = $(
            ".integrations-wrapper .integrations-filter .tab.active"
          ).data("int-type"),
          t = $(".integrations-wrapper .integrations-filter").data("cat"),
          n = $(".integrations-wrapper .integrations-filter").data("btn-text"),
          i = $(".integrations-wrapper.int-template .integrations-list"),
          o = $(".integrations-wrapper .load-wrapper");

        function r(e, t, n) {
          $.ajax({
            url: moosend.ajax_url,
            data: {
              action: "filter_integrations",
              cat: e,
              type: t,
              btnText: n,
            },
            beforeSend: function () {
              i.hide(), o.show();
            },
            success: function (e) {
              var t = $(e);
              o.hide(),
                t.length
                  ? (i.show(), i.html(t))
                  : (i.show(),
                    i.html(
                      '<p style="font-size: 24px; padding: 70px 0; margin: 0 auto;">No items found.</p>'
                    ));
            },
          });
        }
        r(t, e, n);
        $(".integrations-wrapper .integrations-filter .tab").on(
          "click",
          function () {
            (e = $(this).data("int-type")),
              $(".integrations-wrapper .integrations-filter .tab").removeClass(
                "active"
              ),
              $(this).addClass("active"),
              r(t, e, n);
          }
        );
      }
    }),
    $(document).ready(function () {
      $("#login-form").on("submit", function (e) {
        e.preventDefault();
        var t = $(this).find("#username").val(),
          n = $(this).find("#sitename").val(),
          i = $(this).find("#password").val();
        $.ajax({
          url: moosend.ajax_url,
          dataType: "json",
          data: {
            action: "login_moosend",
            nameLogin: t,
            siteNameLogin: n,
            passLogin: i,
          },
          method: "POST",
          success: function (e) {
            var n = 0,
              i = "",
              o = "",
              r = "";
            $.each(e.ValidationErrors, function (e, t) {
              "Domain" == t.Field && ((o = t.Message), n++),
                "UsernameOrEmail" == t.Field && ((i = t.Message), n++),
                "Password" == t.Field && ((r = t.Message), n++);
            }),
              0 == n
                ? (window.location = e)
                : ("" != i &&
                    ($("#username").addClass("validated"),
                    $("#username").next(".error-msg").text(i).animate({
                      opacity: 1,
                    })),
                  "" != o &&
                    ($("#sitename").addClass("validated"),
                    $("#sitename").siblings(".error-msg").text(o).animate({
                      opacity: 1,
                    })),
                  "" != r &&
                    ($("#password").addClass("validated"),
                    $("#password").next(".error-msg").text(r).animate({
                      opacity: 1,
                    })));
          },
        });
      });
    }),
    $(document).ready(function () {
      function t() {
        $(".slick-slide").removeClass("fright"),
          $(".slick-slide").removeClass("sright"),
          $(".slick-slide").removeClass("fleft"),
          $(".slick-slide").removeClass("sleft"),
          $(".slick-center").prev().addClass("fleft"),
          $(".slick-center").prev().prev().addClass("sleft"),
          $(".slick-center").next().addClass("fright"),
          $(".slick-center").next().next().addClass("sright");
      }
      $(".segmentation-carousel").on("init", function (e) {
        t();
      });
      if ($(".segmentation-carousel").length > 0) {
        $(".segmentation-carousel").slick({
          arrows: !0,
          autoplay: !1,
          // slidesToShow: 5,
          centerMode: !0,
          centerPadding: "0",
          variableWidth: !0,
          touchMove: !1,
          draggable: !1,
          nextArrow:
            '<li class="arrow-ctrl next"><i class="fas fa-chevron-right"></i></li>',
          prevArrow:
            '<li class="arrow-ctrl prev"><i class="fas fa-chevron-left"></i></li>',
          appendArrows: $(".segex-arrows"),
          responsive: [
            {
              breakpoint: 993,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
      if ($(".res-carousel-small").length > 0) {
        $(".res-carousel-small").slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: !1,
          arrows: !0,
          autoplay: !1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: !1,
                arrows: !1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: !1,
                arrows: !1,
              },
            },
          ],
        });
      }
      if ($(".res-carousel-big").length > 0) {
        $(".res-carousel-big").slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: !1,
          arrows: !0,
          autoplay: !1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: !1,
                arrows: !1,
              },
            },
          ],
        });
      }
      $(".segmentation-examples .segex-arrows .arrow-ctrl").on(
        "click",
        function () {
          t();
        }
      );

      if ($(window).width() <= 425 && $(".parameters").length > 0) {
        $(".parameters").slick({
          slidesToShow: 1,
          nextArrow:
            '<li class="arrow-ctrl next"><i class="fas fa-chevron-right"></i></li>',
          prevArrow:
            '<li class="arrow-ctrl prev"><i class="fas fa-chevron-left"></i></li>',
          appendArrows: $(".segpar-arrows"),
        });
      }

      if ($(window).width() <= 768) {
        if ($(".automations-slider").length > 0) {
          $(".automations-slider").slick({
            slidesToShow: 1,
            nextArrow:
              '<li class="arrow-ctrl next"><i class="fas fa-chevron-right"></i></li>',
            prevArrow:
              '<li class="arrow-ctrl prev"><i class="fas fa-chevron-left"></i></li>',
            adaptiveHeight: !0,
            fade: !0,
            dots: !0,
            appendArrows: $(".automations-flow .slider-arrows"),
            appendDots: $(".automations-flow .slider-dots"),
          });
        }

        $(".personalization-tabs .tabs-wrapper .tabs").each(function () {
          var $tabs = $(this);
          var $tabsWrapper = $tabs.closest(".tabs-wrapper");

          $tabs.slick({
            slidesToShow: 1,
            nextArrow:
              '<div class="arrow-ctrl next"><i class="fas fa-chevron-right"></i></div>',
            prevArrow:
              '<div class="arrow-ctrl prev"><i class="fas fa-chevron-left"></i></div>',
            dots: !0,
            appendArrows: $tabsWrapper.find(".slider-arrows"),
            appendDots: $tabsWrapper.find(".slider-dots"),
          });
        });
      }

      if ($(".testimonials-slider").length > 0) {
        $(".testimonials-slider").slick({
          arrows: !1,
          dots: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 1,
          asNavFor: ".personal-info",
        });
      }
      if ($(".personal-info").length > 0) {
        $(".personal-info").slick({
          arrows: !1,
          infinite: !0,
          speed: 300,
          slidesToShow: 1,
          asNavFor: ".testimonials-slider",
        });
      }
      $(".menu-trigger").click(function () {
        $(this, ".mmain").toggleClass("open"),
          $(".mmain").toggleClass("open"),
          $("body").toggleClass("mmenu-scroll");
      }),
        $(".mmain .has-sub .arrow, .mmain > ul > li.menu-item-has-children").on(
          "click",
          function () {
            $(this).toggleClass("active"),
              $(".mmain .main-menu > li")
                .not($(this))
                .each(function () {
                  $(this).toggleClass("hidden");
                });
          }
        ),
        $(".centered-box-tabs .tabs-wrapper .tabs a").on("click", function () {
          var e = $(this).data("id");
          $(".tabs-wrapper .tabs a").removeClass("active"),
            $(".centered-box-tabs .box img").hide(),
            $(this).addClass("active"),
            $(".centered-box-tabs .box #img-" + e).fadeIn();
        }),
        $(".automations-flow .tabs li a").on("click", function () {
          var e = $(this).data("slug");
          $(".automations-flow .tabs li a").removeClass("active"),
            $(".automations-flow .wrapper").removeClass("active"),
            $(this).addClass("active"),
            $(".automations-flow #" + e).addClass("active");
        });
      // $(".personalization-tabs .tabs-wrapper .tabs .item").on(
      //   "click",
      //   function () {
      //     var e = $(this).data("id");
      //     $(".personalization-tabs").removeClass("animate"),
      //       $(".personalization-tabs .tabs-wrapper .tabs .item").removeClass(
      //         "active"
      //       ),
      //       $(
      //         ".personalization-tabs .tabs-wrapper .preview .item-wrapper"
      //       ).hide(),
      //       $(this).addClass("active"),
      //       $(
      //         ".personalization-tabs .tabs-wrapper .preview .item-wrapper#" +
      //           e
      //       ).fadeIn();
      //   }
      // );
      var e = $(".tracking-map .tracking-wrapper .preview").width() / 3,
        n = 0;
      $(".map-dots li").on("click", function () {
        $(this).hasClass("next") &&
        !$(".map-dots li.dot:last").hasClass("active")
          ? ($(".map-dots li.dot.active")
              .removeClass("active")
              .next(".dot")
              .addClass("active"),
            (n += e))
          : $(this).hasClass("prev") &&
            !$(".map-dots li.dot:first").hasClass("active")
          ? ($(".map-dots li.dot.active")
              .removeClass("active")
              .prev(".dot")
              .addClass("active"),
            (n -= e))
          : $(this).hasClass("dot") &&
            ($(".map-dots li").removeClass("active"),
            $(this).addClass("active"),
            (n = $(this).data("id") * e)),
          $(".tracking-wrapper .box").scrollLeft(n);
      });
      var i = new ScrollMagic.Controller();
      new ScrollMagic.Scene({
        triggerElement: "[data-animate='animate']",
      })
        .setClassToggle("[data-animate='animate']", "shown")
        .reverse(!1)
        .addTo(i),
        new ScrollMagic.Scene({
          triggerElement: "[data-animate='animate2']",
        })
          .setClassToggle("[data-animate='animate2']", "shown")
          .reverse(!1)
          .addTo(i),
        new ScrollMagic.Scene({
          triggerElement: "[data-animate='animate3']",
        })
          .setClassToggle("[data-animate='animate3']", "shown")
          .reverse(!1)
          .addTo(i);
      new ScrollMagic.Scene({
        triggerElement: "[data-animate='tabs']",
      })
        .setClassToggle("[data-animate='tabs']", "shown")
        .reverse(!1)
        .addTo(i);
      new ScrollMagic.Scene({
        triggerElement: "[data-animate='automation-tree']",
      })
        .setClassToggle(".tree, .tree span", "shown")
        .reverse(!1)
        .addTo(i),
        new ScrollMagic.Scene({
          triggerElement: "[data-animate='mail-tree']",
        })
          .setClassToggle(".tree-screenshots", "shown")
          .reverse(!1)
          .addTo(i),
        new ScrollMagic.Scene({
          triggerElement: "#user",
        })
          .setClassToggle("#user", "active")
          .reverse(!1)
          .addTo(i),
        new ScrollMagic.Scene({
          triggerElement: "[data-animate='customer-list']",
        })
          .setClassToggle("[data-animate='customer-list'] .preview", "active")
          .reverse(!1)
          .addTo(i),
        new ScrollMagic.Scene({
          triggerElement: "[data-animate='compare-animate']",
        })
          .setClassToggle("[data-animate='compare-animate']", "active")
          .reverse(!1)
          .addTo(i),
        $(".load-delay").addClass("show"),
        $(".main-feature.analytics").attr("data-id", "#analytics"),
        $("#categories-menu li a").on("click", function (e) {
          e.preventDefault();
          var t = "";
          (t = $(".main-content#features").length
            ? $('section[data-id="' + $(this).attr("href") + '"]')
            : $("section" + $(this).attr("href"))),
            $("html, body").animate(
              {
                scrollTop: t.offset().top - 80,
              },
              500,
              "linear"
            );
        }),
        $(".cocoen").cocoen();
      var o = new ScrollMagic.Controller({
        globalSceneOptions: {
          duration: "100%",
        },
      });
      $("#categories-menu li a").each(function () {
        var e = "";
        (e = $(".main-content#features").length
          ? '[data-id="' + $(this).attr("href") + '"]'
          : "section" + $(this).attr("href")),
          new ScrollMagic.Scene({
            triggerElement: e,
          })
            .setClassToggle(
              $(this).attr("href", $(this).attr("href"))[0],
              "active"
            )
            .addTo(o);
      });
      if (
        (new ScrollMagic.Scene({
          triggerElement: "[data-animate='reporting-table']",
        })
          .on("start", function () {
            $("section.reporting-table .value").each(function () {
              var e = $(this),
                t = e.attr("data-count");
              $({
                countNum: e.text(),
              }).animate(
                {
                  countNum: t,
                },
                {
                  duration: 4e3,
                  easing: "linear",
                  step: function () {
                    e.text(Math.floor(this.countNum));
                  },
                  complete: function () {
                    e.text(this.countNum);
                  },
                }
              );
            });
          })
          .reverse(!1)
          .addTo(i),
        setTimeout(function () {
          $(".hero-full-customers .hero-wrapper .hero").removeClass("hide");
        }, 500),
        $(".integrations-categories").length)
      ) {
        var r = $(".integrations-categories");
        $(window).on("scroll", function () {
          0 < $(window).scrollTop()
            ? r.addClass("minified")
            : r.removeClass("minified");
        });
      }
      var s = $("#sticky-sidebar");
      if (s.offset()) {
        var a = s.offset().top,
          l = ($(".blog-single-container"), $("footer"));
        $(window).on("scroll", function () {
          var e = s.offset().top,
            t = (s.offset().top, $(this).scrollTop()),
            n = l.offset().top;
          992 < $(this).width()
            ? (((e !== a && t < e) || a - 90 <= t) &&
                s.css({
                  position: "fixed",
                  top: "90px",
                }),
              t < a &&
                s.css({
                  position: "relative",
                  top: "0px",
                }),
              n - a - 700 < t &&
                s.css({
                  position: "absolute",
                  top: n - a - 700 + "px",
                }))
            : s.css({
                position: "relative",
                top: "0px",
              });
        }),
          $(window).on("scroll", function () {
            100 < $(this).scrollTop()
              ? $(".back-to-top").fadeIn()
              : $(".back-to-top").fadeOut();
          }),
          $(window).on("load", function () {
            100 < $(this).scrollTop()
              ? $(".back-to-top").fadeIn()
              : $(".back-to-top").fadeOut();
          }),
          $(".back-to-top").on("click", function () {
            return (
              $("html, body").animate(
                {
                  scrollTop: 0,
                },
                800
              ),
              !1
            );
          });
      }
      $(".level-select-blog-post").on("click", function () {
        var e = $(this).attr("value");
        window.location.href = e;
      }),
        $(window).on("scroll", function () {
          100 < $(this).scrollTop()
            ? $(".back-to-top").fadeIn()
            : $(".back-to-top").fadeOut();
        }),
        $(".back-to-top").on("click", function () {
          return (
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              800
            ),
            !1
          );
        }),
        uriParamValueToLocalStorage("mbsy", "mbsy_short_code"),
        uriParamValueToLocalStorage("campaignid", "campaignid"),
        uriParamValueToLocalStorage("utm_source", "utm_source"),
        uriParamValueToLocalStorage("utm_medium", "utm_medium"),
        uriParamValueToLocalStorage("utm_campaign", "utm_campaign"),
        uriParamValueToLocalStorage("esource", "esource"),
        uriParamValueToLocalStorage("ref", "ref");
    }),
    $(window).on("load", function () {
      if (
        $("section.customers").length ||
        $(".customers-slider-travel").length
      ) {
        $("section.customers").fadeIn(),
          (5 < $(".customers-slider-travel .slider-item").length ||
            $(window).width() <= 769) &&
            $(".customers-slider-travel").slick({
              arrows: !1,
              autoplay: !0,
              slidesToShow: 5,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                  },
                },
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                  },
                },
              ],
            });
      }
      $(".main .main-menu > li .sub").each(function () {
        var e = -94 + $(this).prev().outerWidth();
        $(this).css("left", e);
      }),
        100 < $(this).scrollTop()
          ? $(".back-to-top").fadeIn()
          : $(".back-to-top").fadeOut();
    }),
    $(document).ready(function () {
      var p = $("#step-1"),
        f = $("#step-2"),
        s = $("#step-3"),
        e = {
          first_step: p,
          second_step: f,
          third_step: s,
        },
        t = window.location.hash.substr(1);
      "second_step" == t || "third_step" == t
        ? (e[t].css("display", "block"),
          $("body").addClass("register-bg"),
          $("#login").addClass("window"))
        : (e.first_step.css("display", "flex"),
          $("body").removeClass("register-bg"),
          $("#login").removeClass("window")),
        $(".create-account").on("submit", function (u) {
          u.preventDefault();
          var p = $(this).find('input[name="email"]').val(),
            f = $(this);
          $(this).attr("action");
          $.ajax({
            url: moosend.ajax_url,
            dataType: "json",
            data: {
              action: "register_step",
              email: p,
            },
            method: "POST",
            success: function (e) {
              var n = 0,
                i = "";
              if (
                ($.each(e.ValidationErrors, function (e, t) {
                  "Email" == t.Field && ((i = t.Message), n++);
                }),
                0 == n)
              ) {
                var t = localStorage.getItem("campaignid"),
                  o = localStorage.getItem("mbsy_short_code"),
                  r = localStorage.getItem("affiliateEmail"),
                  s = localStorage.getItem("utm_source"),
                  a = localStorage.getItem("utm_medium"),
                  l = localStorage.getItem("utm_campaign"),
                  c = localStorage.getItem("esource"),
                  d = localStorage.getItem("ref");
                localStorage.clear(),
                  sessionStorage.setItem("redirectFrom", "cta"),
                  localStorage.setItem("campaignid", t),
                  localStorage.setItem("mbsy_short_code", o),
                  localStorage.setItem("affiliateEmail", r),
                  localStorage.setItem("utm_source", s),
                  localStorage.setItem("utm_medium", a),
                  localStorage.setItem("utm_campaign", l),
                  localStorage.setItem("esource", c),
                  localStorage.setItem("ref", d),
                  localStorage.setItem("email", p),
                  localStorage.setItem("referrer", window.location.href),
                  u.currentTarget.submit();
              } else
                f.addClass("validated"),
                  f.next(".error-msg").text(i).animate({
                    opacity: 1,
                  });
            },
          });
        }),
        $("#btn-step-1").on("click", function (e) {
          e.preventDefault();
          var u = $("#email").val();
          $.ajax({
            url: moosend.ajax_url,
            dataType: "json",
            data: {
              action: "register_step",
              email: u,
            },
            method: "POST",
            success: function (e) {
              var n = 0,
                i = "";
              if (
                ($.each(e.ValidationErrors, function (e, t) {
                  "Email" == t.Field && ((i = t.Message), n++);
                }),
                0 == n)
              ) {
                analytics.page({
                  title: "Registration second step",
                  url: "https://moosend.com/register#second_step",
                  path: "/#second_step",
                  referrer: "https://moosend.com/register#first_step",
                });
                var t = localStorage.getItem("campaignid"),
                  o = localStorage.getItem("mbsy_short_code"),
                  r = localStorage.getItem("affiliateEmail"),
                  s = localStorage.getItem("utm_source"),
                  a = localStorage.getItem("utm_medium"),
                  l = localStorage.getItem("utm_campaign"),
                  c = localStorage.getItem("esource"),
                  d = localStorage.getItem("ref");
                localStorage.clear(),
                  localStorage.setItem("campaignid", t),
                  localStorage.setItem("mbsy_short_code", o),
                  localStorage.setItem("affiliateEmail", r),
                  localStorage.setItem("utm_source", s),
                  localStorage.setItem("utm_medium", a),
                  localStorage.setItem("utm_campaign", l),
                  localStorage.setItem("esource", c),
                  localStorage.setItem("ref", d),
                  (window.location = "#second_step"),
                  p.css("display", "none"),
                  f.css("display", "block"),
                  $("body").addClass("register-bg"),
                  $("#login").addClass("window"),
                  localStorage.setItem("email", u);
              } else
                $("#email").addClass("validated"),
                  $("#email").next(".error-msg").text(i).animate({
                    opacity: 1,
                  });
            },
          });
        }),
        $("#btn-step-2").on("click", function (e) {
          e.preventDefault();
          var t = $("#company").val(),
            r = $("#sitename").val();
          $.ajax({
            url: moosend.ajax_url,
            dataType: "json",
            data: {
              action: "register_step",
              company: t,
              sitename: r,
              email: localStorage.getItem("email"),
            },
            method: "POST",
            success: function (e) {
              var n = 0,
                i = "",
                o = "";
              $.each(e.ValidationErrors, function (e, t) {
                "Company" == t.Field && ((i = t.Message), n++),
                  "SiteName" == t.Field && ((o = t.Message), n++);
              }),
                0 == n
                  ? (analytics.page({
                      title: "Registration third step",
                      url: "https://moosend.com/register#third_step",
                      path: "/#third_step",
                      referrer: "https://moosend.com/register#second_step",
                    }),
                    (window.location = "#third_step"),
                    f.css("display", "none"),
                    s.css("display", "block"),
                    localStorage.setItem("company", t),
                    localStorage.setItem("sitename", r))
                  : ("" != i &&
                      ($("#company").addClass("validated"),
                      $("#company").next(".error-msg").text(i).animate({
                        opacity: 1,
                      })),
                    "" != o &&
                      ($("#sitename").addClass("validated"),
                      $("#sitename").siblings(".error-msg").text(o).animate({
                        opacity: 1,
                      })));
            },
          });
        }),
        $("#btn-step-3").on("click", function (e) {
          e.preventDefault();
          var t = $("#name").val(),
            n = $("#password").val();
          $.ajax({
            url: moosend.ajax_url,
            dataType: "json",
            data: {
              action: "register_step",
              step: "final",
              name: t,
              password: n,
              company: localStorage.getItem("company"),
              sitename: localStorage.getItem("sitename"),
              email: localStorage.getItem("email"),
              mbsy: localStorage.getItem("mbsy_short_code"),
              campaignId: localStorage.getItem("campaignid"),
            },
            method: "POST",
            success: function (e) {
              var n = 0,
                i = "",
                o = "";
              if (
                ($.each(e.ValidationErrors, function (e, t) {
                  "Name" == t.Field && ((i = t.Message), n++),
                    "ClearPassword" == t.Field && ((o = t.Message), n++);
                }),
                0 == n)
              ) {
                f.fadeOut(),
                  s.fadeIn(),
                  analytics.page({
                    title: "Registration success",
                    url: "https://moosend.com/register#thankyou",
                    path: "/#thankyou",
                    referrer: "https://moosend.com/register#third_step",
                  });
                var t =
                  "https://" +
                  e.SiteName +
                  ".moosend.com/gotoplatform/" +
                  e.UserId +
                  "/" +
                  e.ApiKey;
                window.location = t;
              } else
                "" != i &&
                  ($("#name").addClass("validated"),
                  $("#name").next(".error-msg").text(i).animate({
                    opacity: 1,
                  })),
                  "" != o &&
                    ($("#password").addClass("validated"),
                    $("#password").next(".error-msg").text(o).animate({
                      opacity: 1,
                    }));
            },
          });
        });
    }),
    $(document).ready(function () {
      if ($(".search-bar").length > 0) {
        var t = $(".search-bar .search .results .list"),
          n = $(".search-bar .search .results .loader"),
          e = $(".search-bar .search form").data("post-type");
        $('.search-bar .search .search-form input[type="text"]').on(
          "keyup",
          function () {
            2 < $(this).val().length
              ? ($(".search-bar .search").addClass("focused"),
                $(
                  ".search-bar .search .results, .search-bar .search-overlay"
                ).fadeIn(),
                $.ajax({
                  method: "GET",
                  url: moosend.ajax_url,
                  data: {
                    action: "search_results",
                    word: $(this).val(),
                    postType: e,
                  },
                  beforeSend: function () {
                    n.show(), t.hide();
                  },
                  success: function (e) {
                    $(e).length
                      ? (n.hide(), t.show(), t.html(e))
                      : (t.show(),
                        t.html("<li>No resources found!</li>"),
                        n.hide());
                  },
                }))
              : ($(".search-bar .search").removeClass("focused"),
                $(
                  ".search-bar .search .results, .search-bar .search-overlay"
                ).fadeOut());
          }
        ),
          $('.search-bar .search .search-form input[type="text"]').on(
            "blur",
            function () {
              $(".search-bar .search").removeClass("focused"),
                $(
                  ".search-bar .search .results, .search-bar .search-overlay"
                ).fadeOut();
            }
          );
      }
      if ($(".integrations-categories").length > 0) {
        var i = $(".integrations-categories .results .list"),
          o = $(".integrations-categories .results .loader");
        $('.integrations-categories .search-form input[type="text"]').on(
          "keyup",
          function () {
            2 < $(this).val().length
              ? ($(".integrations-categories").addClass("focused"),
                $(
                  ".integrations-categories .results, .integrations-categories .search-overlay"
                ).fadeIn(),
                console.log(e),
                $.ajax({
                  method: "GET",
                  url: moosend.ajax_url,
                  data: {
                    action: "search_results",
                    word: $(this).val(),
                    postType: e,
                  },
                  beforeSend: function () {
                    o.show(), i.hide();
                  },
                  success: function (e) {
                    ($results = $(e)),
                      $results.length
                        ? (o.hide(), i.show(), i.html(e))
                        : (i.show(),
                          i.html("<li>No resources found!</li>"),
                          o.hide());
                  },
                }))
              : ($(".integrations-categories").removeClass("focused"),
                $(
                  ".integrations-categories .results, .integrations-categories .search-overlay"
                ).fadeOut());
          }
        ),
          $('.integrations-categories .search-form input[type="text"]').on(
            "blur",
            function () {
              $(".integrations-categories").removeClass("focused"),
                $(
                  ".integrations-categories .results, .integrations-categories .search-overlay"
                ).fadeOut();
            }
          ),
          $(".integrations-categories .wrapper .icon").on("click", function () {
            $(this).next(".search-form").toggle();
          });
      }
    });

  $("form.pg-forms input[type=file]").each(function () {
    $(this)
      .wrap('<div class="pg-file-input-wrapper"></div>')
      .after(
        '<div class="pg-file-input"><div class="pg-file-input__text">Choose a file</div><a href="#" class="pg-file-input__submit">Browse</a></div>'
      );
  }),
    $("form.pg-forms input[type=file]").change(function () {
      $(this)
        .closest(".pg-file-input-wrapper")
        .find(".pg-file-input__text")
        .text($(this).val().split("\\").pop());
    }),
    $(".pg-file-input__submit").click(function (i) {
      i.preventDefault(),
        $(this)
          .closest(".pg-file-input-wrapper")
          .find("input[type=file]")
          .click();
    });
  $(".intercom-popup").click(function (e) {
    e.preventDefault();
    Intercom("showMessages");
  });
})(window, document, jQuery);
